// Skin Products Data
export const skinProducts = [
  {
    id: 'salmon-dna-essence',
    name: 'Salmon DNA Sodium Essence',
    subtitle: 'Water Light Kinetic Essence',
    image: '/images/skinproducts/product1.png',
    shortDescription: 'A lightweight, fast-absorbing essence enriched with Salmon DNA Sodium (PDRN-inspired) to support skin hydration, repair, and revitalization.',
    keyBenefits: [
      {
       
        text: 'Deep hydration with a water-light texture'
      },
      {
        
        text: 'Helps improve skin glow and smoothness'
      },
      {
        
        text: 'Supports skin repair and renewal'
      },
      {
        
        text: 'Enhances skin elasticity and firmness'
      },
      {
        
        text: 'Suitable for dull, dry, and tired-looking skin'
      }
    ],
    keyIngredient: {
      name: 'Salmon DNA Sodium',
      description: 'Known for its skin-revitalizing and regenerative support properties, helping maintain healthier-looking skin and improve overall texture.'
    },
    texture: {
      title: 'Texture & Absorption',
      features: [
        'Ultra-light, non-greasy essence',
        'Absorbs quickly without residue',
        'Suitable for layering under serums or moisturizers'
      ]
    },
    howToUse: [
      'Cleanse your face thoroughly',
      'Apply a few drops evenly over face and neck',
      'Gently massage until fully absorbed',
      'Follow with moisturizer or sunscreen (AM routine)'
    ],
    suitableFor: 'All skin types',
    category: 'essence',
    featured: true
  },
  {
  id: 'remedium-pdrn-ha-complex',
  name: 'ReMedium PDRN + HA Complex',
  subtitle: 'Advanced Polynucleotide Skin Therapy',
  image: '/images/skinproducts/product2.png',
  shortDescription:
    'A powerful bioreparant therapy combining PDRN, Niacinamide, and Hyaluronic Acid to deeply rejuvenate skin, improve radiance, and restore collagen structure.',
  keyBenefits: [
    {  text: 'Stimulates natural collagen production' },
    {  text: 'Improves skin radiance and turgor within 24 hours' },
    {  text: 'Deep hydration through polynucleotide water-binding' },
    {  text: 'Accelerates tissue regeneration and repair' },
    { text: 'Removes free radicals and supports skin immunity' }
  ],
  keyIngredient: {
    name: 'PDRN + Niacinamide + Hyaluronic Acid',
    description:
      'A clinically proven complex (20mg/ml) where PDRN derived from salmon enzymes acts as a collagen builder, niacinamide enhances whitening and lifting, and hyaluronic acid boosts hydration.'
  },
  texture: {
    title: 'Mechanism & Action',
    features: [
      'Embedded into DNA for targeted regeneration',
      'Immunomodulatory and antioxidant action',
      'Activates natural skin renewal processes'
    ]
  },
  howToUse: [
    'Course of 3 procedures',
    'One session every 14 days',
    'Administered via linear retrograde, papular, tubercular, or hot point techniques'
  ],
  suitableFor: 'All skin types with aesthetic concerns',
  category: 'injectable-therapy',
  featured: true
},
{
  id: 'levair-hydration-booster',
  name: 'LeVair',
  subtitle: 'The Ultimate Hydration Skin Booster',
  image: '/images/skinproducts/product3.png',
  shortDescription:
    'World\'s highest HA content skin booster with H-HA + L-HA 100mg, Glycerol 20mg, and Succinic Acid. Enhanced with PDRN, Tranexamic Acid, Glutathione, and Peptide for deep hydration, visible lift, and lasting glow.',
  keyBenefits: [
    { text: 'Deep hydration and long-lasting moisture retention' },
    { text: 'Enhances skin elasticity and smooths fine lines' },
    { text: 'Effectively reduces hyperpigmentation and brightens complexion' },
    { text: 'Promotes skin repair and regeneration by stimulating cell renewal' },
    { text: 'Antioxidant and anti-inflammation protection' }
  ],
  keyIngredient: {
    name: 'H-HA + L-HA 100mg + Glycerol + Succinic Acid',
    description:
      'A perfect combination where Hyaluronic Acid (H-HA 50mg + L-HA 50mg) holds 1,000 times its weight in water for deeply hydrated skin, Glycerol acts as a powerful humectant drawing water into the skin, and Succinic Acid neutralizes free radicals and supports collagen synthesis for firmer, healthier skin.'
  },
  texture: {
    title: 'Hybrid Technology',
    features: [
      'Dual-weight HA for surface hydration and deep absorption',
      'Advanced thermal complex technology for enhanced absorption',
      'Hydrated matrix provides fibroblast activity improving elasticity'
    ]
  },
  howToUse: [
    'BAP Technique (Bio-Aesthetic-Point)',
    'Inject 0.2ml of LeVair into 5 specific points on each side of the face',
    'Use a 29G needle 6-13 mm in length with massage for even distribution'
  ],
  suitableFor: 'All skin types seeking deep hydration, anti-aging benefits, and skin rejuvenation',
  category: 'injectable-skin-booster',
  featured: true
},

{
  id: 'hyaron-skin-booster-skin',
  name: 'Hyaron Skin Booster',
  subtitle: 'Intensive Hyaluronic Acid Hydration Therapy',
  image: '/images/skinproducts/product4.png',
  shortDescription:
    'A high-quality hyaluronic acid skin booster designed to deeply hydrate, improve skin texture, and restore a youthful, radiant appearance.',
  keyBenefits: [
    { text: 'Deeply hydrates dry and dehydrated skin' },
    { text: 'Improves wrinkles, fine lines, and skin elasticity' },
    { text: 'Brightens dull and uneven skin tone' },
    { text: 'Helps reduce acne scars and pigmentation' },
    { text: 'Soothes sensitive skin after cosmetic procedures' }
  ],
  keyIngredient: {
    name: 'Hyaluronic Acid',
    description:
      'A powerful moisture-binding molecule that replenishes skin hydration, improves firmness, and maintains a youthful and healthy appearance.'
  },
  texture: {
    title: 'Mechanism & Action',
    features: [
      'Intense moisture retention within the dermis',
      'Improves skin firmness and suppleness',
      'Enhances overall skin glow and texture'
    ]
  },
  howToUse: [
    'Cleanse and sanitize the skin before treatment',
    'Administer via point-by-point dermal injections or mesogun',
    'Sessions spaced 10–14 days apart',
    'Recommended course of 4–6 sessions with maintenance treatments'
  ],
  suitableFor:
    'Dull, dry, aging, pigmented, acne-scarred, and sensitive skin',
  category: 'injectable-skin-therapy',
  featured: true
},
{
  id: 'pdx-skin-booster',
  name: 'PDX Skin Booster',
  subtitle: 'Professional Application Protocol',
  image: '/images/skinproducts/product5.png',
  shortDescription:
    'Professional-use PDX skin booster for overseas markets, designed for microneedling and injection protocols where legally permitted.',
  keyBenefits: [
    { text: 'Supports skin revitalization and dermal recovery' },
    { text: 'Compatible with microneedling and injection techniques' },
    { text: 'Enhances overall skin condition when applied correctly' },
    { text: 'Helps manage post-procedure skin reactions' },
    { text: 'Designed for professional aesthetic treatments' }
  ],
  keyIngredient: {
    name: 'HA, Peptide, PDRN, Niacinamide',
    description:
      'Active ingredients that support hydration and skin regeneration. Allergy testing is required prior to treatment.'
  },
  texture: {
    title: 'Application Method & Depth',
    features: [
      'Microneedling needle length: 0.3–0.4 mm',
      'Injection using 32–34G needle',
      'Injection depth reaches superficial dermis up to 1–1.5 mm'
    ]
  },
  howToUse: [
    'Use 1 vial per session',
    'Use 3–4 ml per session for full face and neck',
    'Injection dosage: 0.02–0.05 ml per point',
    'No mixing required before application',
    'Microneedling: every 1–2 weeks, minimum of 5 sessions',
    'Injection: every 2–4 weeks, 3–5 sessions depending on skin condition',
    'After recommended sessions, maintenance may be done every 2–3 months',
    'Conduct allergy pre-test under chin or arm and wait 10–15 minutes before treatment'
  ],
  suitableFor:
    'Professional aesthetic procedures performed by qualified practitioners in permitted regions',
  category: 'injectable-skin-therapy',
  featured: true
},


{
  id: 'iskin-radianz-blu-cell-nad-glutathione',
  name: 'iSkin Radianz Blu Cell With NAD Glutathione Injection',
  subtitle: 'High Dose Glutathione',
  image: '/images/skinproducts/product6.png',
  shortDescription:
    'Advanced skin radiance injection formulated with NAD+ and Glutathione to rejuvenate, protect, and brighten the skin.',
  keyBenefits: [
    { text: 'Enhances cellular energy and repairs DNA' },
    { text: 'Reduces fine lines and improves skin firmness' },
    { text: 'Brightens and refreshes skin tone' },
    { text: 'Improves nutrient absorption and overall skin health' },
    { text: 'Provides antioxidant protection and detoxification' }
  ],
  keyIngredient: {
    name: 'NAD+, Marine Cellular Extracts, Phytowhite Tripeptide, Glutathione',
    description: 'Advanced NAD+ and antioxidant complex to support cellular energy, collagen production, and skin radiance.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: ['Administer as directed by a professional'],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: false
},

{
  id: 'glutax-2000000c-dulana-premium-recombined',
  name: 'Glutax 2000000C DULANA',
  subtitle: 'Plus pico quad NA ReCombined',
  image: '/images/skinproducts/product7.png',
  shortDescription:
    'High-dose glutathione injection with advanced formulation combining glutathione, vitamins, amino acids, and NA for skin brightening and anti-aging support.',
  keyBenefits: [
    { text: 'Strengthens immune system' },
    { text: 'Improves memory, focus, and concentration' },
    { text: 'Faster recovery after workouts or surgery' },
    { text: 'Improves detoxification and kidney health' },
    { text: 'Supports skin whitening by reducing melanin formation' }
  ],
  keyIngredient: {
    name: 'Glutathione, NA, Vitamins, Amino Acids',
    description: 'Glutathione with vitamins and amino acids to support skin brightening and antioxidant protection.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: ['Administer as directed by a professional'],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: false
},

{
  id: 'vesco-pharma-collagen-c-1000',
  name: 'Vesco Pharma Collagen C 1000',
  subtitle: 'Collagen & Vitamin C Injection',
  image: '/images/skinproducts/product8.png',
  shortDescription:
    'Advanced collagen injection formulated with collagen extracts and Vitamin C to improve skin elasticity, hydration, and youthful radiance.',
  keyBenefits: [
    { text: 'Significantly reduces wrinkles and fine lines' },
    { text: 'Improves skin elasticity, hydration, and texture' },
    { text: 'Promotes deeper skin hydration and healthy glow' },
    { text: 'Helps even skin tone and reduce hyperpigmentation' },
    { text: 'Boosts collagen production for youthful appearance' }
  ],
  keyIngredient: {
    name: 'Collagen Extracts, Vitamin C, Alpha Lipoic Acid, Hyaluronic Acid, Coenzyme Q10',
    description: 'Collagen and Vitamin C formulation to improve elasticity, hydration, and skin radiance.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: [
    'Initial dose: 1 injection IV or IM every week for up to 1 month',
    'Maintenance dose: 1 injection IV or IM every 2 weeks',
    'Combine with glutathione for optimal results'
  ],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: false
},

{
  id: 'iskin-slc24a5',
  name: 'iSkin SLC24A5',
  subtitle: 'Chromosome Phase IX Glutathione Whitening Injection',
  image: '/images/skinproducts/product9.png',
  shortDescription:
    'Advanced glutathione whitening injection designed to hydrate, brighten, and rejuvenate skin for a flawless complexion.',
  keyBenefits: [
    { text: 'Provides intense hydration and skin brightening' },
    { text: 'Reduces melanin synthesis for lighter skin tone' },
    { text: 'Helps diminish dark spots and signs of aging' },
    { text: 'Supports antioxidant protection and skin repair' },
    { text: 'Promotes youthful, glowing, and flawless skin' }
  ],
  keyIngredient: {
    name: 'Glutathione',
    description: 'Glutathione antioxidant complex to support brightening and cellular protection.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: ['Administer as directed by a professional'],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: false
},

{
  id: 'glutax-3500000gs',
  name: 'Glutax 3500000GS',
  subtitle: 'High Dose Glutathione Injection',
  image: '/images/skinproducts/product10.png',
  shortDescription:
    'High-strength glutathione injection formulated with vitamins and antioxidants to improve skin whitening, elasticity, and overall skin health.',
  keyBenefits: [
    { text: 'Provides nourishment and firmness to the skin' },
    { text: 'Improves collagen production and skin elasticity' },
    { text: 'Reduces dark spots and pigmentation caused by sunlight' },
    { text: 'Smoothens wrinkles and fine lines' },
    { text: 'Boosts skin whitening and antioxidant protection' }
  ],
  keyIngredient: {
    name: 'Glutathione, Vitamin C, Alpha Lipoic Acid, NAC, Selenium, Pro Coenzyme Q10',
    description: 'Antioxidant and whitening blend supporting collagen, detoxification, and skin protection.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: ['Administer as directed by a professional'],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: false
},


{
  id: 'miracle-white-tru-white-transform-25000',
  name: 'Miracle White Tru White Transform',
  subtitle: '25000mg Glutathione',
  image: '/images/skinproducts/product11.png',
  shortDescription:
    'High-dose glutathione formulation designed to support skin whitening, firmness, and youthful radiance.',
  keyBenefits: [
    { text: 'Supports skin whitening and brightening' },
    { text: 'Helps improve skin firmness and youthful appearance' },
    { text: 'Provides antioxidant protection against skin aging' },
    { text: 'Promotes smoother and more even skin tone' },
    { text: 'Supports overall skin rejuvenation' }
  ],
  keyIngredient: {
    name: 'Glutathione & Antioxidants',
    description: 'Concentrated glutathione with antioxidants to support brightening and skin renewal.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: ['Administer as directed by a professional'],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: false
},

{
  id: 'miracle-white-enhanced-90000',
  name: 'Miracle White Enhanced',
  subtitle: '90,000mg Glutathione Whitening Injection',
  image: '/images/skinproducts/product12.png',
  shortDescription:
    'Ultra high-dose glutathione injection with advanced antioxidants and growth factors for intensive skin whitening and rejuvenation.',
  keyBenefits: [
    { text: 'Intensive skin whitening and brightening' },
    { text: 'Powerful antioxidant protection against aging' },
    { text: 'Supports skin firmness and elasticity' },
    { text: 'Promotes collagen production for youthful skin' },
    { text: 'Helps achieve radiant and even skin tone' }
  ],
  keyIngredient: {
    name: 'Concentrated Glutathione & Antioxidants',
    description: 'High-strength glutathione and antioxidant formulation for intensive brightening and protection.'
  },
  texture: {
    title: 'Presentation',
    features: []
  },
  howToUse: ['Administer as directed by a professional'],
  suitableFor: 'All skin types',
  category: 'injectable-skin-therapy',
  featured: true
},
// {
//   "id": "aec",
//   "name": "AEC",
//   "subtitle": "Vitamin A, C & E Anti-Aging Skin Renewal Ampoules",
//   "image": "/images/skinproducts/product13.png",
//   "shortDescription": "As we grow older, our skin’s ability to renew itself slows down. Skin loses its elasticity and wrinkles become more evident. Due to its active components based on Vitamin A, Vitamin C, and Vitamin E, the AEC ampoules provide fast action addressing pigmentation improvement of naturally aged skin.",
  
//   "keyBenefits": [
//     { text: 'Reduces fine lines and wrinkles' },
//     { text: 'Improves skin elasticity and firmness' },
//     { text: 'Enhances skin radiance and complexion' }
//   ],
//   "keyIngredient": {
//     "name": "Retinol, Tocopherol, Ascorbic Acid",
//     "description": "Retinol stimulates collagen production, Tocopherol protects against oxidative stress, and Ascorbic Acid brightens and firms the skin."
//   },
//   "texture": {
//     "title": "Texture & Absorption",
//     "features": ['Lightweight ampoule formula', 'Fast absorbing', 'Suitable for all skin types']
//   },
//   "howToUse": ['Apply 1 ampoule per session', 'Use 2-3 times weekly', 'Follow with appropriate moisturizer'],
//   "suitableFor": "Mature and aging skin",
//   "presentation": "Box 20 x 5 ml ampoules",
//   "category": "anti-aging-therapy",
//   "featured": false
// },

// {
//   "id": "bcomplex",
//   "name": "B-Complex",
//   "subtitle": "Vitamin B Complex Skin Regeneration Therapy",
//   "image": "/images/skinproducts/product14.png",
//   "shortDescription": "Being a vitamin complex with Vitamin B1, B3, B6, B9 and B12, B-Complex aids in skin regeneration, creating new cells, reducing the signs of aging and eliminating blemishes. It helps improve skin conditions such as melasma and psoriasis.",
  
//   "keyBenefits": [
//     { text: 'Promotes cell regeneration and skin renewal' },
//     { text: 'Reduces blemishes and improves clarity' },
//     { text: 'Helps improve melasma and pigmentation issues' }
//   ],
//   "keyIngredient": {
//     "name": "Thiamine HCL, Niacinamide, Pyridoxine, Folic Acid, Cyanocobalamin, Pentapeptide-33",
//     "description": "B-Complex vitamins work synergistically to support cell metabolism, enhance skin barrier function, and promote healthy, clear skin."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": ['Clear liquid formula', 'Easily absorbed', 'Non-irritating']
//   },
//   "howToUse": ['Apply 1 ampoule per session', 'Use weekly for optimal results', 'Can be combined with other treatments'],
//   "suitableFor": "Problem skin and skin conditions",
//   "presentation": "Box 20 x 5 ml ampoules",
//   "category": "skin-therapy",
//   "featured": false
// },


// {
//   "id": "argireline",
//   "name": "Argireline",
//   "subtitle": "Hexapeptide Anti-Wrinkle Skin Therapy",
//   "image": "/images/skinproducts/product15.png",
//   "shortDescription": "The active ingredient of Argireline is a powerful hexapeptide which creates a natural Botox effect on the skin by blocking signals from the nerve to the muscle, preventing neurotransmitters from being released. It is an efficient anti-aging solution that prevents and reduces expression lines.",
  
//   "keyBenefits": [
//     { text: 'Creates natural Botox-like effect' },
//     { text: 'Reduces expression lines and wrinkles' },
//     { text: 'Prevents muscle contractions that cause wrinkles' }
//   ],
//   "keyIngredient": {
//     "name": "Acetyl Hexapeptide-3, Leuphasyl",
//     "description": "Hexapeptide blocks neurotransmitter signals to muscles, relaxing expression lines naturally without injections."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": ['Lightweight formula', 'Easily penetrates skin', 'Works with natural skin biology']
//   },
//   "howToUse": ['Apply topically to expression areas', 'Use daily for best results', 'Massage gently into skin'],
//   "suitableFor": "Expression-prone and aging skin",
//   "presentation": "Box 20 x 2 ml ampoules",
//   "category": "skin-therapy",
//   "featured": false
// },

// {
//   "id": "biotin-hidrizin",
//   "name": "Biotin Hidrizin",
//   "subtitle": "Vitamin B7 Skin & Body Revitalizing Therapy",
//   "image": "/images/skinproducts/product16.png",
//   "shortDescription": "Biotin is a coenzyme known as Vitamin B7, that acts as a natural astringent of the skin and scalp. Especially recommended for oily or combination and sensitive skin. It assists in the production of new cells and helps to balance the sebaceous function, resulting in a healthy skin.",
  
//   "keyBenefits": [
//     { text: 'Balances sebaceous function and controls oil' },
//     { text: 'Promotes new cell production and skin renewal' },
//     { text: 'Supports healthy skin and scalp' }
//   ],
//   "keyIngredient": {
//     "name": "Vitamin B7",
//     "description": "Biotin acts as a natural astringent, strengthening skin and hair while supporting healthy cell growth and metabolism."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": ['Lightweight solution', 'Non-drying formula', 'Balancing properties']
//   },
//   "howToUse": ['Apply 1 ampoule per session', 'Use 2-3 times weekly', 'Suitable for skin and scalp treatment'],
//   "suitableFor": "Oily, combination, and sensitive skin",
//   "presentation": "Box 20 x 2 ml ampoules",
//   "category": "skin-body-therapy",
//   "featured": false
// },

// {
//   "id": "asian-centella",
//   "name": "Asian Centella",
//   "subtitle": "Centella Asiatica Skin Repair & Regeneration Therapy",
//   "image": "/images/skinproducts/product17.png",
//   "shortDescription": "Extract from the leaves or roots of Hydrocotyl Asiatica, Centella Asiatica stimulates the production of collagen, giving the tissue the ability to regain its elasticity. It boosts microcirculation, collagen and skin repairing processes.",
  
//   "keyBenefits": [
//     { text: 'Stimulates collagen production' },
//     { text: 'Boosts microcirculation and skin repair' },
//     { text: 'Protects elastin and hyaluronic acid' }
//   ],
//   "keyIngredient": {
//     "name": "Centella Asiatica Extract",
//     "description": "An herbal extract that activates collagen synthesis, improves blood circulation, and supports skin healing and elasticity."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": ['Natural plant extract', 'Light liquid formula', 'Healing properties']
//   },
//   "howToUse": ['Apply 1 ampoule per session', 'Use 2-3 times weekly', 'Perfect for damaged or irritated skin'],
//   "suitableFor": "Sensitive and damaged skin",
//   "presentation": "Box 20 x 5 ml ampoules",
//   "category": "skin-therapy",
//   "featured": false
// },


// {
//   "id": " collagen-pyruvate",
//   "name": "Collagen Pyruvate",
//   "subtitle": "Skin Regenerative & Anti-Aging Collagen Therapy",
//   "image": "/images/skinproducts/product18.png",
//   "shortDescription": "Collagen Pyruvate has regenerative and healing properties, improving elasticity and hydration of the deep and superficial skin layers.",
  
//   "keyBenefits": [
//     { text: 'Regenerates and heals skin tissue' },
//     { text: 'Improves elasticity and hydration' },
//     { text: 'Reduces flaccidity and stretch marks' }
//   ],
//   "keyIngredient": {
//     "name": "Pyruvic Acid",
//     "description": "Pyruvic acid promotes collagen regeneration and healing while improving skin elasticity and treating signs of aging."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": ['Concentrated formula', 'Deep penetrating', 'Regenerative action']
//   },
//   "howToUse": ['Apply 1 ampoule per session', 'Use 1-2 times weekly', 'Ideal for intensive skin repair'],
//   "suitableFor": "Aging skin and loss of elasticity",
//   "presentation": "Box 20 x 2 ml ampoules",
//   "category": "skin-therapy",
//   "featured": false
// },
// {
//   id: 'deoxythelic-10',
//   name: 'Deoxythelic 10%',
//   subtitle: 'Advanced Depigmentation Solution',
//   image: '/images/skinproducts/product19.png',
//   shortDescription: 'Sodium Deoxycholate is used in the amelioration of labs for the decolorization in injectable. Deoxycholic 10% is an innovative active ingredient.',
//   keyBenefits: [
//     { text: 'Reduces hyperpigmentation and dark spots' },
//     { text: 'Evens out skin tone' },
//     { text: 'Promotes uniform skin appearance' },
//     { text: 'Advanced depigmentation formula' }
//   ],
//   keyIngredient: {
//     name: 'Sodium Deoxycholate',
//     description: 'An active depigmenting ingredient that works to reduce melanin production and treat various skin discolorations and uneven skin tone.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Apply to affected areas',
//     'Follow professional treatment guidelines',
//     'Use as directed by skincare professional'
//   ],
//   suitableFor: 'All skin types concerned with pigmentation',
//   category: 'treatment-serum',
//   featured: false
// },
// {
//   id: 'glutathione',
//   name: 'Glutathione',
//   subtitle: 'Premium Skin Brightening Complex',
//   image: '/images/skinproducts/product20.png',
//   shortDescription: 'Glutathione acts as an important antioxidant in our body, providing the damage caused by free radicals and strengthening the immune system. It is an antiaging ingredient that helps reduce skin damage and promote collagen synthesis.',
//   keyBenefits: [
//     { text: 'Powerful antioxidant protection' },
//     { text: 'Inhibits melanin synthesis' },
//     { text: 'Brightens complexion' },
//     { text: 'Strengthens immune system' },
//     { text: 'Anti-aging support' }
//   ],
//   keyIngredient: {
//     name: 'Glutathione',
//     description: 'A master antioxidant that protects against free radical damage and supports the body\'s natural detoxification while promoting skin brightness and clarity.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 3 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Administer as directed by professional',
//     'Follow recommended treatment protocol',
//     'Consistent application for optimal results'
//   ],
//   suitableFor: 'All skin types',
//   category: 'brightening-serum',
//   featured: false
// },
// {
//   id: 'dmae',
//   name: 'DMAE',
//   subtitle: 'Lifting & Firming Complex',
//   image: '/images/skinproducts/product21.png',
//   shortDescription: 'DMAE, also known as Dimethyl MEA, belongs of the B vitamin Choline. It offers improved regional firmness, creating a visible lifting effect and younger appearance.',
//   keyBenefits: [
//     { text: 'Creates visible lifting effect' },
//     { text: 'Improves skin firmness' },
//     { text: 'Enhances collagen production' },
//     { text: 'Promotes younger appearance' },
//     { text: 'High regeneration properties' }
//   ],
//   keyIngredient: {
//     name: 'DMAE (Dimethyl MEA)',
//     description: 'A B-vitamin derivative that enhances skin muscle tone, increases firmness, and provides a natural lifting effect while supporting collagen enhancement.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML AMPOULES LIQUID'
//     ]
//   },
//   howToUse: [
//     'Apply to targeted areas',
//     'Follow professional application technique',
//     'Use consistently for lifting results'
//   ],
//   suitableFor: 'Mature skin and skin needing lift',
//   category: 'lifting-serum',
//   featured: false
// },
// {
//   id: 'hyaluronic-acid-7',
//   name: 'Hyaluronic acid 1% | 2% | 3.5%',
//   subtitle: 'Deep Hydration & Anti-Aging Solution',
//   image: '/images/skinproducts/product22.jpg',
//   shortDescription: 'Hyaluronic Acid helps in the treatment of wrinkles and expression lines with improved results, improving and maintaining skin hydration. It provides greater elasticity to the skin and increases body elasticity.',
//   keyBenefits: [
//     { text: 'Reduces expression lines and wrinkles' },
//     { text: 'Provides deep hydration' },
//     { text: 'Maintains moisture throughout the day' },
//     { text: 'Plumps and firms skin' },
//     { text: 'Anti-aging support' }
//   ],
//   keyIngredient: {
//     name: 'Hyaluronic Acid (Multi-Weight Complex)',
//     description: 'A hydration powerhouse that holds moisture at the skin surface and penetrates deeper layers, providing comprehensive anti-aging hydration and reducing visible signs of aging.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply after cleansing',
//     'Use morning and evening',
//     'Follow with appropriate moisturizer',
//     'Ideal for layering in skincare routine'
//   ],
//   suitableFor: 'All skin types seeking hydration',
//   category: 'hydrating-serum',
//   featured: false
// },
// {
//   id: 'dna',
//   name: 'DNA',
//   subtitle: 'Cellular Regeneration Complex',
//   image: '/images/skinproducts/product23.png',
//   shortDescription: 'DNA is a biologically active ingredient with high regeneration properties. It promotes excellent collagen enhancement and improves skin texture.',
//   keyBenefits: [
//     { text: 'Stimulates cellular regeneration' },
//     { text: 'Enhances collagen production' },
//     { text: 'Improves skin texture' },
//     { text: 'Reduces wrinkles and fine lines' },
//     { text: 'Treats photo-aging damage' }
//   ],
//   keyIngredient: {
//     name: 'DNA Complex',
//     description: 'A biologically active regenerative ingredient that activates cellular renewal and collagen synthesis, promoting youthful, healthy-looking skin.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML AMPOULES LIQUID'
//     ]
//   },
//   howToUse: [
//     'Apply to clean skin',
//     'Use as part of treatment protocol',
//     'Follow professional recommendations',
//     'Ideal for intensive regeneration therapy'
//   ],
//   suitableFor: 'All skin types concerned with aging',
//   category: 'regeneration-serum',
//   featured: false
// },
// {
//   id: 'l-carnitine',
//   name: 'L-Carnitine',
//   subtitle: 'Bio-Energetic Renewal Solution',
//   image: '/images/skinproducts/product24.png',
//   shortDescription: 'L-Carnitine is an amino acid that is naturally produced in the body, to obtain a valuable and to reduce rest skin and belly fat loss through increased metabolism.',
//   keyBenefits: [
//     { text: 'Boosts cellular energy production' },
//     { text: 'Improves skin cellular turnover' },
//     { text: 'Enhances skin regeneration' },
//     { text: 'Strengthens and tightens skin' },
//     { text: 'Supports skin renewal' }
//   ],
//   keyIngredient: {
//     name: 'L-Carnitine',
//     description: 'A bio-energetic amino acid that activates mitochondrial energy production, enhancing cellular metabolism and promoting visible skin renewal, restoration, and strengthening.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Apply to target areas',
//     'Follow treatment protocol',
//     'Use for cellular energy enhancement',
//     'Best results with consistent use'
//   ],
//   suitableFor: 'Body and facial skin',
//   category: 'bio-energetic-serum',
//   featured: false
// },
// {
//   id: 'lipolytic-plus',
//   name: 'Lipolytic Plus',
//   subtitle: 'Advanced Lipolysis Weight Loss Treatment',
//   image: '/images/skinproducts/product25.png',
//   shortDescription: 'Lipolytic Plus ampules are specially indicated to assist in weight loss treatments. They hydrolyze localized fat and mobilize body contours.',
//   keyBenefits: [
//     { text: 'Assists in weight loss and fat reduction' },
//     { text: 'Hydrolyzes localized fat deposits' },
//     { text: 'Mobilizes body contours and improves shape' }
//   ],
//   keyIngredient: {
//     name: 'Sodium Deoxycholate',
//     description: 'A potent lipolytic agent that breaks down fat cells and promotes fat mobilization for body contouring effects.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Inject into targeted fat areas',
//     'Use as part of body contouring protocol',
//     'Follow professional treatment guidelines'
//   ],
//   suitableFor: 'Body areas with localized fat',
//   category: 'body-contouring',
//   featured: false
// },
// {
//   id: 'vitamin-c-brightening',
//   name: 'Vitamin C',
//   subtitle: 'Powerful Skin Brightening & Antioxidant Complex',
//   image: '/images/skinproducts/product26.png',
//   shortDescription: 'Vitamin C has skin-whitening and antioxidant properties that will protect the skin. This amazing ingredient ensures the appearance of wrinkles and expression lines is minimized. It is also an excellent anti-aging and will give glow. Signs of chosen skin tone and color will fade with adequate use.',
//   keyBenefits: [
//     { text: 'Brightens skin and improves skin tone' },
//     { text: 'Powerful antioxidant protection' },
//     { text: 'Reduces wrinkles and expression lines' }
//   ],
//   keyIngredient: {
//     name: 'Ascorbic Acid',
//     description: 'A potent antioxidant vitamin that brightens skin, neutralizes free radicals, and stimulates collagen production for youthful skin.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 3 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Apply 1 ampoule per session',
//     'Use 2-3 times weekly',
//     'Follow with moisturizer and sunscreen'
//   ],
//   suitableFor: 'All skin types seeking brightening and anti-aging',
//   category: 'brightening-antioxidant',
//   featured: false
// },
// {
//   id: 'phosphatidylcholine',
//   name: 'Phosphatidylcholine',
//   subtitle: 'Lipolytic & Cellulite Reduction Therapy',
//   image: '/images/skinproducts/product27.png',
//   shortDescription: 'Phosphatidylcholine is a lipid form of Lecithin, which is an enzyme or metabolic derivative such as an antiaging protein. It is recommended as an anti-fat weight loss solution, stimulating the inflammatory apparatus. It is a very effective therapy to ensure smaller localized fats in weight.',
//   keyBenefits: [
//     { text: 'Reduces localized fat deposits' },
//     { text: 'Improves cellulite appearance' },
//     { text: 'Supports body contouring and fat mobilization' }
//   ],
//   keyIngredient: {
//     name: 'Lecithin',
//     description: 'A lipid compound that breaks down fat cells and promotes lipolysis, helping reduce localized fat and improve body shape.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 5 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Inject into areas with localized fat',
//     'Use as part of fat reduction protocol',
//     'Follow professional treatment standards'
//   ],
//   suitableFor: 'Body contouring and cellulite reduction',
//   category: 'lipolytic-therapy',
//   featured: false
// },
// {
//   id: 'hyaluronic-acid-dmae-combo',
//   name: 'Hyaluronic acid + DMAE',
//   subtitle: 'Hydration & Lifting Complex',
//   image: '/images/skinproducts/product28.png',
//   shortDescription: 'Hyaluronic Acid + DMAE is a powerful combination that helps in the treatment of dehydrated skin and wrinkles. By stimulating the fibroblast, this complex improves the treatment of lines. It allows lifting and micro-circulation improved skins.',
//   keyBenefits: [
//     { text: 'Deep hydration and moisture retention' },
//     { text: 'Creates visible lifting and firming effect' },
//     { text: 'Reduces wrinkles and fine lines' }
//   ],
//   keyIngredient: {
//     name: 'Dimethyl MEA, Hyaluronic Acid',
//     description: 'DMAE provides natural lifting and muscle toning while hyaluronic acid delivers intense hydration, creating a comprehensive anti-aging and firming solution.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply 1 vial per session',
//     'Use 1-2 times weekly',
//     'Ideal for facial lifting and hydration'
//   ],
//   suitableFor: 'Dehydrated skin and aging concerns',
//   category: 'hydrating-lifting',
//   featured: false
// },
// {
//   id: 'vitamin-a-retinol',
//   name: 'Vitamin A',
//   subtitle: 'Premium Retinol Anti-Aging Renewal Serum',
//   image: '/images/skinproducts/product29.png',
//   shortDescription: 'Vitamin A stimulates collagen synthesis and reverses the signs of pre-mature aging. By increasing skin elasticity while enhancing skin firmness, it provides an efficient anti-aging solution.',
//   keyBenefits: [
//     { text: 'Stimulates collagen synthesis' },
//     { text: 'Reverses signs of premature aging' },
//     { text: 'Increases skin elasticity and firmness' }
//   ],
//   keyIngredient: {
//     name: 'Retinol Palmitate',
//     description: 'A potent retinoid form of Vitamin A that activates collagen production and supports skin renewal for anti-aging benefits.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 2 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Apply to clean skin',
//     'Use 1-2 times weekly',
//     'Follow with appropriate moisturizer'
//   ],
//   suitableFor: 'Aging skin and premature aging concerns',
//   category: 'anti-aging-retinol',
//   featured: false
// },
// {
//   id: 'fat-burner-cocktail',
//   name: 'Fat Burner',
//   subtitle: 'Advanced Lipolytic Cocktail Solution',
//   image: '/images/skinproducts/product30.png',
//   shortDescription: 'The active ingredients of Fat Burner cocktail, such as Caffeine, Organic Plant Extracts are very effective in stimulating fat reduction. All the ingredients are clinically proven to aid in burning fat and supporting body contour improvements.',
//   keyBenefits: [
//     { text: 'Stimulates fat reduction and metabolism' },
//     { text: 'Supports body contouring improvements' },
//     { text: 'Enhances lipolysis and fat burning' }
//   ],
//   keyIngredient: {
//     name: 'Caffeine, Hydrolyzed Mandarake, Carnitine, Ascorbic Potassium',
//     description: 'A comprehensive fat-burning cocktail where caffeine boosts metabolism, plant extracts enhance lipolysis, carnitine supports fat burning, and ascorbic potassium provides antioxidant support.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Administer as directed by professional',
//     'Use as part of fat reduction protocol',
//     'Follow professional treatment guidelines'
//   ],
//   suitableFor: 'Body contouring and fat reduction',
//   category: 'fat-burner-cocktail',
//   featured: false
// },
// {
//   id: 'out-contour-face',
//   name: 'Out Contour',
//   subtitle: 'Advanced Eye & Facial Contour Treatment',
//   image: '/images/skinproducts/product31.png',
//   shortDescription: 'Out Contour is ideal for eye bags, dark circles and wrinkles can make you look tired, unhealthy and old skin before your time. The active ingredients of Out Contour cocktail aim to solve these problems and reduce wrinkles in the surrounding areas around the eyes by tightening contours.',
//   keyBenefits: [
//     { text: 'Reduces eye bags and dark circles' },
//     { text: 'Minimizes wrinkles around eyes' },
//     { text: 'Tightens and firms eye contours' }
//   ],
//   keyIngredient: {
//     name: 'Hyaluronic Acid, Hexapeptide, Caffeine, Deoxycholic',
//     description: 'A comprehensive formula combining hyaluronic acid for hydration, hexapeptide for lifting, caffeine for de-puffing, and deoxycholic for skin tightening.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply around eye area',
//     'Use morning and evening',
//     'Can be layered under other products'
//   ],
//   suitableFor: 'Tired eyes, dark circles, and eye area wrinkles',
//   category: 'eye-contour',
//   featured: false
// },
// {
//   id: 'antiaging-cocktail',
//   name: 'Antiaging',
//   subtitle: 'Comprehensive Anti-Aging Cocktail',
//   image: '/images/skinproducts/product32.png',
//   shortDescription: 'Antiaging cocktail is rich in antioxidants and Panthenol, DMAE, Orgain, Silicon and Ceramide to help prevent and delay visible signs of aging. The active ingredients in the formula increase skin luminosity and moisture while reducing wrinkles and fine lines.',
//   keyBenefits: [
//     { text: 'Prevents and delays aging signs' },
//     { text: 'Increases skin luminosity and glow' },
//     { text: 'Reduces wrinkles and fine lines' }
//   ],
//   keyIngredient: {
//     name: 'Panthenol, DMAE, Orgain, Silicon, Ceramide',
//     description: 'A synergistic blend where panthenol hydrates, DMAE lifts, orgain nourishes, silicon strengthens, and ceramide supports skin barrier health.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply 1 vial per session',
//     'Use 2-3 times weekly',
//     'Ideal for facial renewal protocols'
//   ],
//   suitableFor: 'All aging skin types',
//   category: 'anti-aging-cocktail',
//   featured: false
// },
// {
//   id: 'melanoout',
//   name: 'MelanoOut',
//   subtitle: 'Advanced Melanin & Pigmentation Reduction Treatment',
//   image: '/images/skinproducts/product33.png',
//   shortDescription: 'MelanoOut cocktail is designed for people who wish to reduce dark spots and also pigmentation. It is especially recommended to mesure skin problems such as hyperpigmentation and specific recommendations are placed on the melanin formula.',
//   keyBenefits: [
//     { text: 'Reduces dark spots and pigmentation' },
//     { text: 'Inhibits melanin production' },
//     { text: 'Brightens and evens skin tone' }
//   ],
//   keyIngredient: {
//     name: 'Kojic Acid, Glutathione, Ascorbic Acid, Arbutin',
//     description: 'A potent depigmenting complex where kojic acid and arbutin inhibit melanin, glutathione detoxifies, and ascorbic acid brightens the complexion.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply to pigmented areas',
//     'Use 2-3 times weekly',
//     'Always use with SPF protection'
//   ],
//   suitableFor: 'Hyperpigmented and dark spot-prone skin',
//   category: 'melanin-reduction',
//   featured: false
// },
// {
//   id: 'peptone-growth-factor',
//   name: 'Peptone Growth Factor',
//   subtitle: 'Growth Factor Anti-Wrinkle Renewal Cocktail',
//   image: '/images/skinproducts/product34.png',
//   shortDescription: 'Peptone Growth Factor is rich in peptides and helps to reduce wrinkles, dark spots and acne scars and acne scars. The active ingredients decrease the appearance of wrinkles volume and tightens skin.',
//   keyBenefits: [
//     { text: 'Reduces wrinkles and fine lines' },
//     { text: 'Minimizes dark spots and scars' },
//     { text: 'Enhances skin volume and firmness' }
//   ],
//   keyIngredient: {
//     name: 'Peptides, Hexapeptide-8, Arginine, Ascorbic Acid',
//     description: 'A growth factor-rich formula where peptides stimulate collagen, hexapeptide provides lifting, arginine improves circulation, and ascorbic acid brightens.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply to facial skin',
//     'Use 1-2 times weekly',
//     'Ideal for intensive renewal treatments'
//   ],
//   suitableFor: 'Mature skin and scar-prone areas',
//   category: 'growth-factor-peptide',
//   featured: false
// },
// {
//   id: 'whitening-cocktail',
//   name: 'Whitening',
//   subtitle: 'Premium Skin Brightening & Whitening Cocktail',
//   image: '/images/skinproducts/product35.png',
//   shortDescription: 'Whitening cocktail combines Glutathione, Vitamin C and Patolic Acid, an antioxidant blend designed to offer flawless, white and unblemished skin. The comprehensive formula offers protection against sun damage, antioxidants and promotes radiant skin.',
//   keyBenefits: [
//     { text: 'Brightens and whitens skin complexion' },
//     { text: 'Reduces dark spots and pigmentation' },
//     { text: 'Provides antioxidant protection' }
//   ],
//   keyIngredient: {
//     name: 'Glutathione, Vitamin C, Patolic Acid',
//     description: 'A powerful brightening blend where glutathione whitens and detoxifies, Vitamin C brightens and protects, and patolic acid provides additional antioxidant benefits.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply 1 vial per session',
//     'Use 2-3 times weekly',
//     'Always follow with sun protection'
//   ],
//   suitableFor: 'All skin types seeking brightening',
//   category: 'whitening-brightening',
//   featured: false
// },
// {
//   id: 'cellulite-reduction',
//   name: 'Cellulite',
//   subtitle: 'Cellulite & Body Contouring Solution',
//   image: '/images/skinproducts/product36.png',
//   shortDescription: 'Cellulite cocktail is an effective solution to reduce localized fat and reduce the appearance of cellulite. It combines Caffeine, L-Carnitine and cellulite-reduction properties, enabling firmness to the skin. Used in weight loss programs.',
//   keyBenefits: [
//     { text: 'Reduces cellulite appearance' },
//     { text: 'Targets localized fat deposits' },
//     { text: 'Improves skin firmness and tone' }
//   ],
//   keyIngredient: {
//     name: 'Caffeine, L-Carnitine, Methylxanthine, Centella Asiatica Extract',
//     description: 'A powerful cellulite-fighting formula where caffeine and methylxanthine enhance lipolysis, L-carnitine burns fat, and Centella promotes skin firmness.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Apply to cellulite areas',
//     'Use 2-3 times weekly',
//     'Ideal for body contouring protocols'
//   ],
//   suitableFor: 'Cellulite and body contouring concerns',
//   category: 'cellulite-reduction',
//   featured: false
// },
// {
//   id: 'skin-repair-complex',
//   name: 'Skin Repair',
//   subtitle: 'Revitalizing & Moisturizing Repair Complex',
//   image: '/images/skinproducts/product37.png',
//   shortDescription: 'Skin Repair cocktail is specially formulated as a powerful revitalizing and moisturizing serum for facial care. It is perfect for tired and damaged skin. The active ingredients create elasticity, being effective in wrinkles, flaccidity and dehydrated skin treatments.',
//   keyBenefits: [
//     { text: 'Revitalizes tired and damaged skin' },
//     { text: 'Provides deep hydration and moisture' },
//     { text: 'Improves elasticity and reduces wrinkles' }
//   ],
//   keyIngredient: {
//     name: 'Panthenol, Glycerol, Hyaluronic Acid, Sodium Hyaluronate',
//     description: 'A comprehensive repair formula where panthenol soothes, glycerol hydrates, and hyaluronic acid provides intensive moisture for skin restoration.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 5 x 5 ML VIALS'
//     ]
//   },
//   howToUse: [
//     'Apply to clean facial skin',
//     'Use daily for optimal hydration',
//     'Can be layered with other serums'
//   ],
//   suitableFor: 'Tired, damaged, and dehydrated skin',
//   category: 'skin-repair-hydrating',
//   featured: false
// },
// {
//   id: 'pdrn-ha-injectable',
//   name: 'PDRN + HA',
//   subtitle: 'Advanced Polynucleotide Hydration & Rejuvenation',
//   image: '/images/skinproducts/product38.png',
//   shortDescription: 'The active ingredients of PDRN + HA with regenerative properties increase skin hydration and promote cellular renewal. It is an antioxidant and astringent. It promotes skin rejuvenation and the capillary structure strengthening for hydrated and youthful-looking skin.',
//   keyBenefits: [
//     { text: 'Increases skin hydration and moisture retention' },
//     { text: 'Reduces wrinkles, expression lines and age spots' },
//     { text: 'Promotes skin rejuvenation and cellular regeneration' }
//   ],
//   keyIngredient: {
//     name: 'Hyaluronic Acid, Deoxycholate Acid',
//     description: 'A potent combination where PDRN activates cellular regeneration and collagen synthesis, while hyaluronic acid provides intensive hydration for plump, youthful skin.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       '5 Vial x 5 ml',
//       'Injectable treatment',
//       'Medical-grade formula'
//     ]
//   },
//   howToUse: [
//     'Administer via professional injection',
//     'Can be used on face, neck, and hands',
//     'Follow professional treatment protocol'
//   ],
//   suitableFor: 'Face, neck, and hands wrinkle treatment',
//   category: 'pdrn-injectable-therapy',
//   featured: false
// },
// {
//   id: 'renew-essence-ha',
//   name: 'Renew Essence + HA',
//   subtitle: 'Anti-Inflammatory Cellulite & Fat Reduction Syringe',
//   image: '/images/skinproducts/product39.png',
//   shortDescription: 'A powerful anti-inflammatory syringe induced by inflammatory mediators. It is widely used to treat cellulite and localized fat. Artichoke extract stimulates the lymphatic circulation, reducing liquid retention.',
//   keyBenefits: [
//     { text: 'Reduces cellulite and localized fat' },
//     { text: 'Improves fluid metabolism and lymphatic circulation' },
//     { text: 'Decreases liquid retention and supports weight loss' }
//   ],
//   keyIngredient: {
//     name: 'Artichoke Extract, Sodium Hyaluronate',
//     description: 'Artichoke extract stimulates lymphatic circulation and reduces inflammation while sodium hyaluronate provides hydration. Together they improve metabolic function and reduce localized fat accumulation.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       '1 or 2 Syringe x 10ml',
//       'Injectable anti-inflammatory formula',
//       'Direct application treatment'
//     ]
//   },
//   howToUse: [
//     'Inject into cellulite and fat areas',
//     'Follow professional treatment protocol',
//     'Use as part of body contouring program'
//   ],
//   suitableFor: 'Cellulite, localized fat, and weight loss',
//   category: 'cellulite-fat-reduction',
//   featured: false,
//   productCode: 'OS20/OS21'
// },
// {
//   id: 'shock-brightening-ha',
//   name: 'Shock Brightening + HA',
//   subtitle: 'Advanced Brightening & Anti-Aging Syringe',
//   image: '/images/skinproducts/product40.png',
//   shortDescription: 'This syringe is a powerful anti-inflammatory combination recommended to reduce skin problems such as hyperpigmentation and age spots. It transverses photoshading, improves acne scars and gives the skin a more youthful appearance.',
//   keyBenefits: [
//     { text: 'Reduces hyperpigmentation and age spots' },
//     { text: 'Improves acne scars and skin blemishes' },
//     { text: 'Provides photoprotection and collagen activation' }
//   ],
//   keyIngredient: {
//     name: 'Niacinamide, Ascorbyl Glucamine, Ascorbic Acid',
//     description: 'A powerful brightening blend where niacinamide protects and synthesizes, ascorbyl glucamine provides antioxidant protection, and ascorbic acid brightens and stimulates collagen for youthful skin.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       '1 or 2 Syringe x 10ml',
//       'Injectable brightening treatment',
//       'Photoprotective formula'
//     ]
//   },
//   howToUse: [
//     'Inject into pigmented areas',
//     'Use as photoprotective treatment',
//     'Follow professional injection protocol'
//   ],
//   suitableFor: 'Hyperpigmentation, blemishes, dark spots, and melasma',
//   category: 'brightening-injection-therapy',
//   featured: false
// },
{
  id: 'mooyam-24k-gold-serum-mask',
  name: 'MOOYAM 24K Gold Serum Facial Mask',
  subtitle: 'Lightweight, Breathable Face Mask',
  image: '/images/skinproducts/41.jpeg',
  shortDescription:
    'A luxurious 24K gold serum facial mask designed to provide layer-by-layer hydration and anti-aging benefits with a lightweight, breathable formula.',
  keyBenefits: [
    { text: 'Layer-by-layer hydration for deep moisture penetration' },
    { text: 'Anti-aging properties to reduce fine lines and wrinkles' },
    { text: 'Lightweight and breathable for comfortable wear' },
    { text: 'Enhances skin radiance with 24K gold essence' },
    { text: 'Improves skin elasticity and firmness' }
  ],
  keyIngredient: {
    name: '24K Gold Serum',
    description:
      'Pure 24K gold infused serum provides luxurious anti-aging benefits, boosts circulation, and enhances skin luminosity for a radiant, youthful glow.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, breathable serum mask',
      'Non-greasy formula with smooth application',
      'Quick absorption with long-lasting hydration',
      'Suitable for all skin types'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply the mask evenly over face and neck',
    'Leave on for 15-20 minutes',
    'Remove gently and pat in any remaining serum',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dull and aging skin',
  category: 'face-mask',
  featured: true
},
{
  id: 'mooyam-hyaluronic-acid-serum-mask',
  name: 'MOOYAM Hyaluronic Acid Serum Facial Mask',
  subtitle: 'Lightweight, Breathable Face Mask',
  image: '/images/skinproducts/42.jpeg',
  shortDescription:
    'A refreshing hyaluronic acid serum facial mask that provides intensive hydration, reduces fine lines, and minimizes pore size with layer-by-layer moisture penetration.',
  keyBenefits: [
    { text: 'Layer-by-layer hydration for intense moisture penetration' },
    { text: 'Reduces fine lines and wrinkles effectively' },
    { text: 'Minimizes pore size for smoother skin appearance' },
    { text: 'Lightweight and breathable formula' },
    { text: 'Enhances skin firmness and elasticity' }
  ],
  keyIngredient: {
    name: 'Hyaluronic Acid',
    description:
      'High-concentration hyaluronic acid holds up to 1,000 times its weight in water, providing deep hydration and restoring skin plumpness for a youthful, radiant complexion.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, refreshing serum mask',
      'Non-greasy, breathable formula',
      'Quick absorption with long-lasting hydration',
      'Suitable for all skin types'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply the mask evenly over face and neck',
    'Leave on for 15-20 minutes',
    'Remove gently and pat in any remaining serum',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dry and mature skin',
  category: 'face-mask',
  featured: true
},
{
  id: 'mooyam-vitamin-c-serum-mask',
  name: 'MOOYAM Vitamin C Serum Facial Mask',
  subtitle: 'Lightweight, Breathable Face Mask',
  image: '/images/skinproducts/43.jpeg',
  shortDescription:
    'A brightening vitamin C serum facial mask that provides layer-by-layer hydration, whitens skin, brightens complexion, and evens skin tone.',
  keyBenefits: [
    { text: 'Layer-by-layer hydration for deep moisture penetration' },
    { text: 'Brightens dull and uneven skin tone' },
    { text: 'Provides powerful antioxidant protection' },
    { text: 'Reduces dark spots and hyperpigmentation' },
    { text: 'Enhances natural skin radiance and glow' }
  ],
  keyIngredient: {
    name: 'Vitamin C',
    description:
      'High-potency vitamin C brightens skin, promotes collagen synthesis, and provides antioxidant protection against environmental damage while evening out skin tone and reducing discoloration.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, brightening serum mask',
      'Non-greasy, breathable formula',
      'Smooth, luxurious texture',
      'Quick absorption with lasting radiance'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply the mask evenly over face and neck',
    'Leave on for 15-20 minutes',
    'Remove gently and pat in any remaining serum',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dull and hyperpigmented skin',
  category: 'face-mask',
  featured: true
},
{
  id: 'mooyam-retinol-serum-mask',
  name: 'MOOYAM Retinol Serum Facial Mask',
  subtitle: 'Lightweight, Breathable Face Mask',
  image: '/images/skinproducts/44.jpeg',
  shortDescription:
    'A powerful retinol serum facial mask that firms, tightens, and delivers anti-aging benefits. Enriched with vitamins A, B, E to resist wrinkles and promote skin renewal.',
  keyBenefits: [
    { text: 'Firms and tightens skin for a lifted appearance' },
    { text: 'Powerful anti-aging and wrinkle-resisting properties' },
    { text: 'Stimulates collagen production and skin renewal' },
    { text: 'Reduces fine lines and improves skin texture' },
    { text: 'Lightweight and breathable formula' }
  ],
  keyIngredient: {
    name: 'Retinol with Vitamins A, B, E',
    description:
      'Advanced retinol complex combined with essential vitamins promotes skin cell turnover, boosts collagen synthesis, and provides powerful anti-aging benefits while nourishing and protecting the skin.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, smoothing serum mask',
      'Non-greasy, breathable formula',
      'Absorbs quickly with firming effect',
      'Suitable for mature and aging skin'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply the mask evenly over face and neck',
    'Leave on for 15-20 minutes',
    'Remove gently and pat in any remaining serum',
    'Use 2-3 times per week for best results',
    'Use sunscreen during the day as retinol increases sun sensitivity'
  ],
  suitableFor: 'Mature skin, aging skin, and those seeking anti-aging benefits',
  category: 'face-mask',
  featured: true
},
{
  id: 'mooyam-collagen-serum-mask',
  name: 'MOOYAM Collagen Serum Facial Mask',
  subtitle: 'Lightweight, Breathable Face Mask',
  image: '/images/skinproducts/45.jpeg',
  shortDescription:
    'A luxurious collagen serum facial mask that smooths, firms, and provides elastic skin benefits. Creates a beautiful skin plump with layer-by-layer hydration and elasticity restoration.',
  keyBenefits: [
    { text: 'Smooth and delicate firming effects' },
    { text: 'Enhances skin elasticity and firmness' },
    { text: 'Creates beautiful skin plump and volume' },
    { text: 'Layer-by-layer hydration and nourishment' },
    { text: 'Improves overall skin texture and radiance' }
  ],
  keyIngredient: {
    name: 'Marine Collagen',
    description:
      'Premium marine collagen works deeply to restore skin elasticity, improve firmness, and create a plump, youthful appearance while providing intensive hydration and nourishment.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, nourishing serum mask',
      'Non-greasy, silky formula',
      'Quick absorption with firming effect',
      'Suitable for all skin types'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply the mask evenly over face and neck',
    'Leave on for 15-20 minutes',
    'Remove gently and pat in any remaining serum',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dull, sagging, and inelastic skin',
  category: 'face-mask',
  featured: true
},
{
  id: 'mooyam-snail-serum-mask',
  name: 'MOOYAM Snail Serum Facial Mask',
  subtitle: 'Lightweight, Breathable Face Mask',
  image: '/images/skinproducts/46.jpeg',
  shortDescription:
    'A regenerative snail serum facial mask that provides intensive skin renewal and rejuvenation. Delivers cell rejuvenation, moisturizing, and anti-aging benefits for beautiful, healthy skin.',
  keyBenefits: [
    { text: 'Intensive cell rejuvenation and renewal' },
    { text: 'Deep moisturizing and hydration benefits' },
    { text: 'Anti-aging and skin regeneration properties' },
    { text: 'Soothes and calms sensitive skin' },
    { text: 'Improves skin elasticity and radiance' }
  ],
  keyIngredient: {
    name: 'Snail Secretion Filtrate',
    description:
      'Natural snail secretion filtrate is rich in glycoproteins and enzymes that promote cellular rejuvenation, enhance healing, and provide intensive hydration and anti-aging benefits.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, rejuvenating serum mask',
      'Non-greasy, gentle formula',
      'Quick absorption with long-lasting hydration',
      'Suitable for all skin types including sensitive skin'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply the mask evenly over face and neck',
    'Leave on for 15-20 minutes',
    'Remove gently and pat in any remaining serum',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially sensitive, damaged, and mature skin',
  category: 'face-mask',
  featured: true
},
{
  id: 'bamboo-charcoal-jelly-mask',
  name: 'Bamboo Charcoal Jelly Mask',
  subtitle: 'Shrink Pores & Deeply Clean',
  image: '/images/skinproducts/47.jpeg',
  shortDescription:
    'An effective purifying bamboo charcoal jelly mask that shrinks pores and deeply cleanses the skin. Draws out impurities and removes dead skin cells for a clean, refined complexion.',
  keyBenefits: [
    { text: 'Effectively shrinks and minimizes pores' },
    { text: 'Deeply cleanses and removes impurities' },
    { text: 'Extracts blackheads and excess oil' },
    { text: 'Removes dead skin cells and debris' },
    { text: 'Creates smooth, refined skin texture' }
  ],
  keyIngredient: {
    name: 'Bamboo Charcoal with Hyaluronic Acid',
    description:
      'Activated bamboo charcoal acts as a powerful absorbent drawing out impurities and toxins from pores, while hyaluronic acid provides hydration to balance the purifying action.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth jelly consistency for easy application',
      'Peelable gel formula',
      'Charcoal-infused for deep cleansing',
      'Leaves skin clean and refined'
    ]
  },
  howToUse: [
    'Cleanse your face thoroughly',
    'Apply an even layer of the jelly mask over face (avoiding eye area)',
    'Leave on for 15-20 minutes until fully dry',
    'Gently peel off the mask',
    'Rinse with lukewarm water',
    'Apply moisturizer to nourish cleansed skin',
    'Use 1-2 times per week for best results'
  ],
  suitableFor: 'Oily, combination, and acne-prone skin',
  category: 'peel-off-mask',
  featured: true
},
{
  id: 'vampire-plla-infusion-mask',
  name: 'Vampire PLLA Infusion Jelly Mask',
  subtitle: 'Poly-L-Lactic Acid Jelly Mask',
  image: '/images/skinproducts/48.jpeg',
  shortDescription:
    'An innovative Poly-L-Lactic Acid (PLLA) jelly mask that effectively moisturizes and plumps skin while promoting skin firmness and anti-aging. Enriched with Hyaluronic Acid and collagen for enhanced results.',
  keyBenefits: [
    { text: 'Stimulates collagen production for firmer skin' },
    { text: 'Intensive moisturizing and plumping effect' },
    { text: 'Promotes skin lifting and tightening' },
    { text: 'Anti-aging and rejuvenating properties' },
    { text: 'Improves skin elasticity and resilience' }
  ],
  keyIngredient: {
    name: 'Poly-L-Lactic Acid (PLLA) with Hyaluronic Acid & Collagen',
    description:
      'PLLA is a biocompatible ingredient that stimulates natural collagen production, while Hyaluronic Acid and Collagen provide intense hydration and structural support for firmer, more youthful-looking skin.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth, luxurious jelly consistency',
      'Peelable gel mask formula',
      'Rich, nourishing texture',
      'Leaves skin soft and plump'
    ]
  },
  howToUse: [
    'Cleanse and tone your face thoroughly',
    'Apply an even layer of the jelly mask over face (avoiding eye and lip area)',
    'Leave on for 15-20 minutes until set',
    'Gently peel off the mask from the edges',
    'Rinse with lukewarm water and pat dry',
    'Apply your regular skincare routine',
    'Use 2-3 times per week for optimal results'
  ],
  suitableFor: 'All skin types, especially mature, dull, and inelastic skin',
  category: 'peel-off-mask',
  featured: true
},
{
  id: 'hyaluronic-acid-jelly-mask',
  name: 'Hyaluronic Acid Jelly Mask',
  subtitle: 'Moisturize & Whiten',
  image: '/images/skinproducts/49.jpeg',
  shortDescription:
    'An effective hyaluronic acid jelly mask that moisturizes and whitens skin. Enriched with Sodium Alginate, Calcium Sulfate, and natural ingredients to provide intense hydration and brightening effects.',
  keyBenefits: [
    { text: 'Intensive moisturizing and hydration' },
    { text: 'Whitening and brightening effects' },
    { text: 'Reduces dark spots and discoloration' },
    { text: 'Improves skin luminosity and radiance' },
    { text: 'Gentle and suitable for all skin types' }
  ],
  keyIngredient: {
    name: 'Hyaluronic Acid with Sodium Alginate & Calcium Sulfate',
    description:
      'Hyaluronic acid holds 1,000 times its weight in water for deep hydration, while sodium alginate and calcium sulfate create a hydrating gel matrix that lifts and firms the skin while promoting brightness.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth, lightweight jelly consistency',
      'Peelable gel mask formula',
      'Non-irritating and hydrating',
      'Creates a refreshing cooling effect'
    ]
  },
  howToUse: [
    'Cleanse your face thoroughly',
    'Apply an even layer of the jelly mask over face (avoiding eye and lip area)',
    'Leave on for 15-20 minutes until fully set',
    'Gently peel off the mask from the edges',
    'Rinse with lukewarm water and pat dry',
    'Apply your regular skincare routine',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dry, dull, and hyperpigmented skin',
  category: 'peel-off-mask',
  featured: true
},
{
  id: 'kiwi-fruit-jelly-mask',
  name: 'Kiwi Fruit Jelly Mask',
  subtitle: 'Prevent Aging & Brightening',
  image: '/images/skinproducts/50.jpeg',
  shortDescription:
    'An effective kiwi fruit jelly mask that prevents aging and brightens skin. Enriched with natural kiwi fruit extract and seeds, plus sodium hyaluronate for anti-aging and brightening benefits.',
  keyBenefits: [
    { text: 'Prevents signs of aging effectively' },
    { text: 'Brightens and evens skin tone' },
    { text: 'Rich in antioxidants from kiwi fruit' },
    { text: 'Intensive hydration with sodium hyaluronate' },
    { text: 'Promotes radiant, youthful-looking skin' }
  ],
  keyIngredient: {
    name: 'Kiwi Fruit Extract & Sodium Hyaluronate',
    description:
      'Natural kiwi fruit extract is rich in vitamins, minerals, and antioxidants that brighten and protect skin, while sodium hyaluronate provides deep hydration and supports anti-aging benefits.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Light green, fruity-scented jelly consistency',
      'Peelable gel mask formula',
      'Non-greasy and refreshing',
      'Leaves skin smooth and radiant'
    ]
  },
  howToUse: [
    'Cleanse your face thoroughly',
    'Apply an even layer of the jelly mask over face (avoiding eye and lip area)',
    'Leave on for 15-20 minutes until fully set',
    'Gently peel off the mask from the edges',
    'Rinse with lukewarm water and pat dry',
    'Apply your regular skincare routine',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dull, mature, and aging skin',
  category: 'peel-off-mask',
  featured: true
},
{
  id: 'tea-tree-jelly-mask',
  name: 'Tea Tree',
  subtitle: 'Acne Treatment & After-Sun Repair Jelly Mask',
  image: '/images/skinproducts/51.jpeg',
  shortDescription: 'An effective jelly mask formulated with Tea Tree extract to treat acne, repair after-sun damage, and provide soothing relief for troubled skin.',
  keyBenefits: [
    { text: 'Efficiently improves acne problems and breakouts' },
    { text: 'Repairs skin after sun exposure' },
    { text: 'Soothing and calming for irritated skin' },
    { text: 'Easy to apply and remove with gel-like texture' },
    { text: 'Helps purify and clarify skin'
    }
  ],
  keyIngredient: {
    name: 'Tea Tree Extract',
    description: 'A natural antibacterial and antifungal ingredient known for its effectiveness in treating acne and soothing inflamed skin.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Lightweight gel-like jelly texture',
      'Easy to apply and massage on face and neck',
      'Peels off cleanly without residue',
      'Non-greasy and comfortable to wear'
    ]
  },
  howToUse: [
    'After facial cleansing, apply the jelly mask evenly over face and neck',
    'Use purified water if needed to aid application',
    'Leave on for 15-20 minutes until set',
    'Gently peel off and remove',
    'Rinse thoroughly with water for a pickle-free finish'
  ],
  suitableFor: 'Acne-prone, oily, and sensitive skin',
  category: 'mask',
  featured: false
},
{
  id: 'lemon-jelly-mask',
  name: 'Lemon',
  subtitle: 'Whitening & Antioxidative Jelly Mask',
  image: '/images/skinproducts/52.jpeg',
  shortDescription: 'A brightening jelly mask formulated with Lemon extract to help even skin tone, control oil, reduce dark spots, and provide antioxidant protection.',
  keyBenefits: [
    { text: 'Brightens and helps reduce dark spots' },
    { text: 'Antioxidative protection against free radicals' },
    { text: 'Oil control and reduces shine' },
    { text: 'Anti-wrinkle and skin tightening support' },
    { text: 'Improves skin repair and radiance' }
  ],
  keyIngredient: {
    name: 'Lemon Extract',
    description: 'Rich in vitamin C and antioxidants; helps brighten skin, reduce pigmentation, and support skin renewal.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Lightweight jelly texture',
      'Easy to spread and forms an even film',
      'Peels off cleanly after setting',
      'Non-sticky and comfortable on skin'
    ]
  },
  howToUse: [
    'After cleansing, apply an even layer of the jelly mask over face (avoid eye and lip areas)',
    'Leave on for 15-20 minutes until fully set',
    'Gently peel off from the edges',
    'Rinse with lukewarm water and pat dry',
    'Use 2-3 times per week for best results'
  ],
  suitableFor: 'All skin types, especially dull and pigmented skin',
  category: 'mask',
  featured: false
},
{
  id: 'collagen-jelly-mask',
  name: 'Collagen',
  subtitle: 'Moisturing & Nutritional Supplement Jelly Mask',
  image: '/images/skinproducts/53.jpeg',
  shortDescription: 'A moisturizing jelly mask enriched with collagen to support skin elasticity, hydration, and a nourished complexion.',
  keyBenefits: [
    { text: 'Deep hydration and moisture retention' },
    { text: 'Supports skin elasticity and firmness' },
    { text: 'Nourishes and improves skin texture' },
    { text: 'Helps reduce the appearance of fine lines' },
    { text: 'Comforting, non-greasy jelly feel' }
  ],
  keyIngredient: {
    name: 'Collagen',
    description: 'Hydrolyzed collagen helps replenish the skin’s matrix, improving elasticity and supporting a plumper, more youthful appearance.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Creamy jelly consistency',
      'Spreads evenly and forms a gentle film',
      'Peels off cleanly after setting',
      'Non-sticky and lightweight on skin'
    ]
  },
  howToUse: [
    'After cleansing, apply a thin, even layer across face avoiding eyes and lips',
    'Leave on for 15-20 minutes until set',
    'Gently peel off from the edges and rinse any residue',
    'Pat dry and continue with your regular skincare routine',
    'Use 2-3 times weekly for best results'
  ],
  suitableFor: 'All skin types, especially dehydrated or aging skin',
  category: 'mask',
  featured: false
},


{
  id: 'bulgarian-rose-jelly-mask',
  name: 'Bulgarian Rose',
  subtitle: 'Whitening & Skin Refining Jelly Mask',
  image: '/images/skinproducts/54.jpeg',
  shortDescription: 'A soothing jelly mask infused with Bulgarian Rose extract to brighten, hydrate, and improve overall skin tone while enhancing skin delicacy.',
  keyBenefits: [
    { text: 'Helps brighten and even out skin tone' },
    { text: 'Improves skin softness and delicacy' },
    { text: 'Provides deep hydration and nourishment' },
    { text: 'Soothes and refreshes tired skin' },
    { text: 'Enhances natural glow and clarity' }
  ],
  keyIngredient: {
    name: 'Bulgarian Rose Extract',
    description: 'Rich in antioxidants and soothing properties, Bulgarian Rose extract helps hydrate, calm irritation, and improve skin radiance.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth jelly-like consistency',
      'Spreads easily across the skin',
      'Forms a flexible peel-off layer',
      'Lightweight and cooling feel'
    ]
  },
  howToUse: [
    'Cleanse your face thoroughly before application',
    'Apply a thin, even layer avoiding eyes, lips, and eyebrows',
    'Leave on for 15–20 minutes until fully set',
    'Gently peel off from the edges',
    'Rinse any residue and follow with moisturizer'
  ],
  suitableFor: 'All skin types, especially dull and dehydrated skin',
  category: 'mask',
  featured: false
},


{
  id: 'provence-lavender-jelly-mask',
  name: 'Provence Lavender',
  subtitle: 'Calm & Repair Jelly Mask',
  image: '/images/skinproducts/55.jpeg',
  shortDescription: 'A calming jelly mask enriched with Provence Lavender extract to soothe sensitive skin, reduce irritation, and support skin repair.',
  keyBenefits: [
    { text: 'Calms irritated and sensitive skin' },
    { text: 'Helps repair and restore skin balance' },
    { text: 'Reduces redness and discomfort' },
    { text: 'Provides gentle hydration and nourishment' },
    { text: 'Promotes a relaxed, refreshed complexion' }
  ],
  keyIngredient: {
    name: 'Lavender Extract',
    description: 'Lavender extract is known for its soothing and anti-inflammatory properties, helping to calm stressed skin and support natural repair.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Soft jelly-like texture',
      'Spreads smoothly without tugging',
      'Sets into a flexible peel-off layer',
      'Cooling and non-sticky finish'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly before use',
    'Apply an even layer avoiding eyes, lips, and eyebrows',
    'Leave on for 15–20 minutes until fully set',
    'Gently peel off from edges',
    'Rinse residue and apply moisturizer'
  ],
  suitableFor: 'All skin types, especially sensitive and irritated skin',
  category: 'mask',
  featured: false
},


{
  id: 'luxury-24k-gold-jelly-mask',
  name: 'Luxury 24K Gold',
  subtitle: 'Anti-Aging & Antioxidant Jelly Mask',
  image: '/images/skinproducts/56.jpeg',
  shortDescription: 'A premium jelly mask infused with 24K Gold to help fight signs of aging, protect against environmental stress, and improve skin radiance.',
  keyBenefits: [
    { text: 'Helps reduce the appearance of fine lines and wrinkles' },
    { text: 'Provides antioxidant protection against skin damage' },
    { text: 'Improves skin firmness and elasticity' },
    { text: 'Enhances skin brightness and glow' },
    { text: 'Refines pores and smooths skin texture' }
  ],
  keyIngredient: {
    name: '24K Gold',
    description: '24K Gold helps boost skin radiance, supports collagen function, and provides antioxidant benefits to combat visible signs of aging.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Silky jelly texture with a luxurious feel',
      'Spreads evenly for full facial coverage',
      'Sets into a flexible peel-off layer',
      'Non-greasy and comfortable on skin'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly before application',
    'Apply a thin, even layer avoiding eyes and lips',
    'Leave on for 15–20 minutes until fully set',
    'Gently peel off from edges',
    'Rinse residue and continue skincare routine'
  ],
  suitableFor: 'All skin types, especially mature and dull skin',
  category: 'mask',
  featured: false
},

{
  id: 'chamomile-petals-jelly-mask',
  name: 'Chamomile Petals',
  subtitle: 'Moisturize & Repair Jelly Mask',
  image: '/images/skinproducts/57.jpeg',
  shortDescription: 'A gentle jelly mask infused with chamomile petals to deeply moisturize, soothe irritation, and support skin repair.',
  keyBenefits: [
    { text: 'Deeply moisturizes and nourishes skin' },
    { text: 'Soothes irritation and redness' },
    { text: 'Supports skin repair and recovery' },
    { text: 'Improves skin softness and comfort' },
    { text: 'Leaves skin calm and refreshed' }
  ],
  keyIngredient: {
    name: 'Chamomile Extract',
    description: 'Chamomile extract is known for its calming and anti-inflammatory properties, helping to soothe sensitive skin and promote repair.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Soft jelly texture with botanical petals',
      'Spreads evenly and comfortably',
      'Sets into a peel-off layer',
      'Non-sticky and cooling on skin'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly before use',
    'Apply an even layer avoiding eyes and lips',
    'Leave on for 15–20 minutes until fully set',
    'Gently peel off from edges',
    'Rinse residue and apply moisturizer'
  ],
  suitableFor: 'All skin types, especially dry and sensitive skin',
  category: 'mask',
  featured: false
},


{
  id: 'pure-himalayan-jelly-mask',
  name: 'Pure Himalayan',
  subtitle: 'Calm, Hydrating & Repair Jelly Mask',
  image: '/images/skinproducts/58.jpeg',
  shortDescription: 'A soothing jelly mask designed to calm stressed skin, restore hydration, and support overall skin repair and balance.',
  keyBenefits: [
    { text: 'Deeply hydrates and replenishes skin' },
    { text: 'Calms sensitive and irritated skin' },
    { text: 'Supports skin repair and strengthening' },
    { text: 'Improves skin smoothness and tone' },
    { text: 'Enhances natural skin balance' }
  ],
  keyIngredient: {
    name: 'Himalayan Botanical Complex',
    description: 'A blend inspired by Himalayan botanicals that helps soothe, hydrate, and restore skin’s natural resilience.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth jelly consistency',
      'Lightweight and refreshing feel',
      'Forms a flexible peel-off layer',
      'Comfortable for regular use'
    ]
  },
  howToUse: [
    'Cleanse face before application',
    'Apply a thin, even layer avoiding eyes and lips',
    'Leave on for 15–20 minutes until set',
    'Peel off gently and rinse residue',
    'Follow with moisturizer or serum'
  ],
  suitableFor: 'All skin types, especially sensitive and dehydrated skin',
  category: 'mask',
  featured: false
},


{
  id: 'vitamin-c-jelly-mask',
  name: 'Vitamin C',
  subtitle: 'Brighten & Remove Freckle Jelly Mask',
  image: '/images/skinproducts/59.jpeg',
  shortDescription: 'A brightening jelly mask enriched with Vitamin C to improve skin tone, reduce dullness, and enhance overall radiance.',
  keyBenefits: [
    { text: 'Brightens and evens skin tone' },
    { text: 'Helps reduce appearance of freckles and spots' },
    { text: 'Boosts skin radiance and clarity' },
    { text: 'Provides antioxidant protection' },
    { text: 'Refreshes tired-looking skin' }
  ],
  keyIngredient: {
    name: 'Vitamin C',
    description: 'Vitamin C helps brighten the complexion, reduce pigmentation, and protect skin from environmental damage.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth jelly texture',
      'Easy to spread evenly',
      'Peels off cleanly after setting',
      'Lightweight and non-greasy finish'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly',
    'Apply an even layer avoiding eyes and lips',
    'Leave on for 15–20 minutes',
    'Peel off gently from edges',
    'Rinse and follow with skincare routine'
  ],
  suitableFor: 'All skin types, especially dull and uneven skin tone',
  category: 'mask',
  featured: false
},


{
  id: 'taygete-carbon-gel',
  name: 'TAYGETE Carbon Gel',
  subtitle: 'Carbon Laser Treatment Gel',
  image: '/images/skinproducts/60.jpeg',
  shortDescription: 'A professional-grade carbon gel designed for carbon laser treatments to deeply cleanse pores, absorb excess oil, and improve skin texture.',
  keyBenefits: [
    { text: 'Deeply cleanses pores during carbon laser treatment' },
    { text: 'Helps control excess oil and sebum' },
    { text: 'Improves skin texture and smoothness' },
    { text: 'Supports brightening and rejuvenation treatments' },
    { text: 'Enhances laser treatment effectiveness' }
  ],
  keyIngredient: {
    name: 'Activated Carbon',
    description: 'Activated carbon effectively absorbs oil, impurities, and debris from pores, making it ideal for carbon laser facial treatments.'
  },
  texture: {
    title: 'Texture & Application',
    features: [
      'Smooth gel consistency',
      'Spreads evenly on skin',
      'Dries into a thin carbon layer',
      'Non-greasy and easy to remove'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly before application',
    'Apply a thin, even layer of carbon gel to treatment area',
    'Allow gel to dry completely',
    'Proceed with carbon laser treatment as directed by a professional',
    'Remove residue and apply soothing skincare post-treatment'
  ],
  suitableFor: 'All skin types, especially oily and acne-prone skin',
  category: 'treatment-gel',
  featured: false
  },
{
  id: 'omega-light-dual-fog',
  name: 'Omega Light With Dual Fog Skin Care',
  subtitle: 'Advanced LED Light Therapy System',
  image: '/images/skinproducts/62.png',
  shortDescription: 'Professional-grade LED light therapy device with dual fog technology for comprehensive skin rejuvenation, collagen stimulation, and anti-aging treatment.',
  keyBenefits: [
    { text: 'Stimulates collagen production and skin elasticity' },
    { text: 'Reduces fine lines, wrinkles, and signs of aging' },
    { text: 'Improves skin tone and texture' },
    { text: 'Reduces inflammation and acne breakouts' },
    { text: 'Non-invasive with no downtime required' }
  ],
  keyIngredient: {
    name: 'Multi-wavelength LED Technology',
    description: 'Advanced LED light therapy with dual fog function for enhanced skin penetration and rejuvenation results.'
  },
  texture: {
    title: 'Technology & Features',
    features: [
      'Professional-grade LED light therapy',
      'Dual fog skin care technology',
      'Multiple treatment wavelengths',
      'Easy-to-use control panel',
      'Suitable for all skin types'
    ]
  },
  howToUse: [
    'Cleanse and prepare skin before treatment',
    'Apply appropriate skincare products as needed',
    'Position device over treatment area',
    'Select desired light wavelength and intensity',
    'Treatment duration typically 15-30 minutes',
    'Repeat sessions 1-3 times per week for optimal results'
  ],
  suitableFor: 'All skin types, especially aging and acne-prone skin',
  category: 'light-therapy-device',
  featured: true
},
{
  id: 'spa-omega-light-high-quality',
  name: 'SPA Omega Light High Quality Skin Therapy',
  subtitle: 'Premium LED Skin Rejuvenation',
  image: '/images/skinproducts/63.png',
  shortDescription: 'Premium SPA-grade omega light therapy system designed for intensive skin rejuvenation, brightening, and anti-aging treatments in professional settings.',
  keyBenefits: [
    { text: 'Promotes skin brightening and radiance' },
    { text: 'Enhances skin firmness and elasticity' },
    { text: 'Reduces hyperpigmentation and dark spots' },
    { text: 'Stimulates natural collagen regeneration' },
    { text: 'Provides anti-inflammatory benefits' }
  ],
  keyIngredient: {
    name: 'Premium LED Light Wavelengths',
    description: 'High-quality LED light technology with multiple wavelengths for comprehensive skin rejuvenation and therapeutic benefits.'
  },
  texture: {
    title: 'Premium Features',
    features: [
      'SPA-grade professional equipment',
      'Multiple light wavelengths',
      'High-intensity LED system',
      'Adjustable treatment settings',
      'Advanced cooling technology'
    ]
  },
  howToUse: [
    'Perform professional facial cleanse',
    'Apply protective eye gear',
    'Select appropriate light wavelength',
    'Adjust intensity based on skin sensitivity',
    'Treat face and neck area for 20-30 minutes',
    'Apply soothing serum post-treatment'
  ],
  suitableFor: 'All skin types, ideal for professional spa treatments',
  category: 'spa-light-therapy',
  featured: true
},
{
  id: 'omega-light-u-shape-facial',
  name: 'Omega Light U Shape Model Facial Lifting Device',
  subtitle: 'Advanced Facial Lifting & Tightening',
  image: '/images/skinproducts/64.png',
  shortDescription: 'Innovative U-shaped LED light therapy device specifically designed for facial lifting, skin tightening, and contouring with advanced light technology.',
  keyBenefits: [
    { text: 'Provides non-invasive facial lifting and tightening' },
    { text: 'Improves jawline definition and contour' },
    { text: 'Reduces sagging skin and loss of elasticity' },
    { text: 'Stimulates deep collagen production' },
    { text: 'Visible results with consistent use' }
  ],
  keyIngredient: {
    name: 'U-Shaped LED Light System',
    description: 'Ergonomically designed U-shape with advanced LED technology for precise facial lifting and tightening treatment.'
  },
  texture: {
    title: 'Lifting Technology',
    features: [
      'U-shaped ergonomic design',
      'Targeted facial contouring',
      'Advanced LED lifting mechanism',
      'Adjustable intensity levels',
      'Suitable for all facial zones'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly',
    'Apply lifting serum or moisturizer',
    'Position U-shaped device along jawline and face',
    'Activate light therapy on desired intensity',
    'Move device upward in lifting motions for 15-20 minutes',
    'Use 2-3 times per week for optimal lifting results'
  ],
  suitableFor: 'All skin types seeking facial lifting and tightening',
  category: 'facial-lifting-device',
  featured: true
},
{
  id: 'diamond-dermabrasion-machine',
  name: 'Diamond Dermabrasion Machine Skin Rejuvenation',
  subtitle: 'Professional Microdermabrasion System',
  image: '/images/skinproducts/65.png',
  shortDescription: 'Professional-grade diamond dermabrasion machine for exfoliation, skin resurfacing, and treatment of acne scars, wrinkles, and uneven skin texture.',
  keyBenefits: [
    { text: 'Effectively exfoliates and removes dead skin cells' },
    { text: 'Reduces appearance of acne scars and pitting' },
    { text: 'Improves fine lines and wrinkles' },
    { text: 'Evens out skin tone and texture' },
    { text: 'Promotes cell regeneration and collagen production' }
  ],
  keyIngredient: {
    name: 'Diamond Tip Technology',
    description: 'Advanced diamond-tipped heads for gentle yet effective mechanical exfoliation and skin resurfacing treatments.'
  },
  texture: {
    title: 'Dermabrasion System',
    features: [
      'Multiple diamond tip sizes available',
      'Adjustable suction levels',
      'Professional-grade motor',
      'Digital display and controls',
      'Cordless and portable design'
    ]
  },
  howToUse: [
    'Cleanse and dry skin completely',
    'Apply appropriate pre-treatment serum',
    'Select appropriate diamond tip for treatment area',
    'Adjust suction and speed settings',
    'Move device in gentle upward motions over face',
    'Treatment duration typically 20-30 minutes',
    'Apply soothing mask and moisturizer post-treatment'
  ],
  suitableFor: 'All skin types, especially acne-prone and aging skin',
  category: 'dermabrasion-device',
  featured: true
},
{
  id: '3-in-1-diamond-dermabrasion',
  name: '3 in 1 Diamond Dermabrasion Machine Professional',
  subtitle: 'Multi-Function Skin Rejuvenation System',
  image: '/images/skinproducts/66.png',
  shortDescription: 'Multi-functional 3-in-1 professional dermabrasion machine combining diamond dermabrasion, vacuum therapy, and spray technology for comprehensive skin treatment.',
  keyBenefits: [
    { text: 'Three treatment modes in one device' },
    { text: 'Comprehensive skin exfoliation and rejuvenation' },
    { text: 'Improves skin absorption of serums and products' },
    { text: 'Reduces fine lines, wrinkles, and scars' },
    { text: 'Promotes bright, smooth, and healthy-looking skin' }
  ],
  keyIngredient: {
    name: '3-in-1 Technology System',
    description: 'Combines diamond microdermabrasion, vacuum suction, and spray therapy for enhanced skin treatment results.'
  },
  texture: {
    title: 'Multi-Function Features',
    features: [
      'Diamond dermabrasion tip',
      'Vacuum therapy suction system',
      'Spray atomization technology',
      'Adjustable intensity levels',
      'Professional-grade equipment'
    ]
  },
  howToUse: [
    'Cleanse face thoroughly before treatment',
    'Select desired treatment function',
    'Apply appropriate skincare serum',
    'Begin with lower intensity and gradually increase',
    'Treat all facial areas with gentle upward motions',
    'Complete treatment in 25-35 minutes',
    'Apply cooling mask and hydrating serum after'
  ],
  suitableFor: 'All skin types for comprehensive skin rejuvenation',
  category: 'multi-function-device',
  featured: true
},
{
  id: 'diamond-dermabrasion-spray',
  name: 'Diamond Dermabrasion Spray Model Professional',
  subtitle: 'Advanced Spray Dermabrasion Therapy',
  image: '/images/skinproducts/67.png',
  shortDescription: 'Professional diamond dermabrasion device with integrated spray technology for advanced skin exfoliation, cleansing, and rejuvenation with optimal hydration.',
  keyBenefits: [
    { text: 'Combines mechanical exfoliation with spray hydration' },
    { text: 'Removes dead skin cells while delivering treatment serums' },
    { text: 'Improves skin texture and clarity' },
    { text: 'Reduces pores and refines skin appearance' },
    { text: 'Prevents dryness during exfoliation treatment' }
  ],
  keyIngredient: {
    name: 'Diamond Tip + Spray Technology',
    description: 'Advanced combination of diamond exfoliation with synchronized spray delivery for enhanced skincare treatment efficacy.'
  },
  texture: {
    title: 'Spray Technology',
    features: [
      'Synchronized diamond and spray function',
      'Adjustable spray mist levels',
      'Professional diamond tips',
      'Multiple treatment programs',
      'Efficient and comfortable treatment'
    ]
  },
  howToUse: [
    'Prepare face with cleanser',
    'Fill spray reservoir with appropriate serum or essence',
    'Select treatment program',
    'Begin with lower intensity settings',
    'Apply device to facial areas with gentle motions',
    'Treatment duration 20-30 minutes',
    'Finish with soothing and hydrating skincare'
  ],
  suitableFor: 'All skin types, especially sensitive and dehydrated skin',
  category: 'spray-dermabrasion',
  featured: true
},
{
  id: 'diamond-micro-carving-kit',
  name: 'Diamond Micro Carving Grinding Kit Professional',
  subtitle: 'Advanced Micro-Abrasion System',
  image: '/images/skinproducts/68.png',
  shortDescription: 'Professional diamond micro carving kit featuring multiple grinding and sculpting tools for precision skin resurfacing, scar treatment, and advanced aesthetic procedures.',
  keyBenefits: [
    { text: 'Precision micro-abrasion for targeted skin treatment' },
    { text: 'Effective for deep scars and textural issues' },
    { text: 'Customizable treatment with multiple tool options' },
    { text: 'Promotes collagen remodeling and skin smoothing' },
    { text: 'Professional-grade results for aesthetic practices' }
  ],
  keyIngredient: {
    name: 'Diamond Micro-Carving Tool System',
    description: 'Comprehensive kit with multiple diamond-tipped carving and grinding tools for precision skin resurfacing and micro-abrasion treatments.'
  },
  texture: {
    title: 'Professional Kit Contents',
    features: [
      'Multiple precision grinding tips',
      'Various carving and sculpting tools',
      'Diamond-coated treatment heads',
      'Professional carrying case included',
      'Suitable for clinical use'
    ]
  },
  howToUse: [
    'Sanitize and sterilize all tools before use',
    'Cleanse treatment area thoroughly',
    'Select appropriate tool for target area',
    'Use with proper suction and safety equipment',
    'Apply micro-carving with precision and control',
    'Treatment duration varies by area and concern',
    'Apply protective and soothing post-treatment serum'
  ],
  suitableFor: 'Professional aesthetic practices, specialized scar treatment',
  category: 'professional-micro-carving',
  featured: true

},
{
  id: 'gfc-growth-factor-concentrate',
  name: 'GFC (Growth Factor Concentrate) Gel',
  subtitle: 'Concentrated Growth Factor Serum',
  image: '/images/skinproducts/69.png',
  shortDescription: 'High-concentration growth factor gel formulated to support skin regeneration, healing, and post-procedure recovery.',
  keyBenefits: [
    { text: 'Accelerates wound healing and tissue regeneration' },
    { text: 'Supports collagen and elastin production' },
    { text: 'Improves skin texture and elasticity' },
    { text: 'Useful post-aesthetic procedures' }
  ],
  keyIngredient: {
    name: 'Growth Factor Complex',
    description: 'A blend of growth factors and peptides to support cellular repair and regeneration.'
  },
  texture: {
    title: 'Gel Texture',
    features: ['Light gel, quick-absorbing', 'Non-greasy finish', 'Suitable for layering']
  },
  howToUse: ['Cleanse skin', 'Apply a thin layer to treated area', 'Use as part of post-procedure care'],
  suitableFor: 'All skin types, especially post-procedure skin',
  category: 'growth-factor-serum',
  featured: true
},
{
  id: 'hydra-trolley-metal',
  name: 'Hydra Trolley Metal Beauty Trolley',
  subtitle: 'Mobile Treatment Equipment Stand',
  image: '/images/skinproducts/70.png',
  shortDescription: 'Sturdy metal trolley with multiple shelves and wheels designed to organize and transport aesthetic devices and supplies in clinics and spas.',
  keyBenefits: [
    { text: 'Durable metal construction' },
    { text: 'Multiple storage shelves' },
    { text: 'Smooth-rolling caster wheels for mobility' }
  ],
  keyIngredient: {
    name: 'Stainless Metal Frame',
    description: 'Corrosion-resistant metal designed for clinical environments.'
  },
  texture: { title: 'Build & Features', features: ['Stable metal frame', 'Lockable wheels', 'Compact footprint'] },
  howToUse: ['Assemble according to instructions', 'Load equipment securely', 'Lock wheels when stationary'],
  suitableFor: 'Clinics, spas, and beauty salons',
  category: 'equipment',
  featured: false
},

{
  id: 'dermaheal-hsr',
  name: 'Dermaheal HSR (Hyaluronic Skin Rejuvenation)',
  subtitle: 'Hyaluronic & Peptide Skin Rejuvenation Ampoule',
  image: '/images/skinproducts/71.png',
  shortDescription: 'Dermaheal HSR ampoules combine hyaluronic acid and peptides to hydrate, rejuvenate, and improve skin elasticity for a long-lasting glow.',
  keyBenefits: [
    { text: 'Deep hydration and plumping' },
    { text: 'Improves skin elasticity and texture' },
    { text: 'Supports collagen production' }
  ],
  keyIngredient: { name: 'Hyaluronic Acid + Peptides', description: 'Hydrating and regenerative ingredients for skin rejuvenation.' },
  texture: { title: 'Ampoule', features: ['Clear liquid', 'Fast-absorbing'] },
  howToUse: ['Use via mesotherapy, injection, or microneedling as directed by professionals'],
  suitableFor: 'Dry, aging, or dull skin',
  category: 'injectable-serum',
  featured: true
},
{
  id: 'dermaheal-sr',
  name: 'Dermaheal SR (Skin Rejuvenation)',
  subtitle: 'Regenerative Skin Rejuvenation Solution',
  image: '/images/skinproducts/72.png',
  shortDescription: 'Dermaheal SR designed to revitalize and restore skin using a blend of growth factors and peptides tailored for rejuvenation treatments.',
  keyBenefits: [
    { text: 'Stimulates skin regeneration' },
    { text: 'Improves skin tone and firmness' },
    { text: 'Reduces appearance of fine lines' }
  ],
  keyIngredient: { name: 'Growth factors & peptides', description: 'Clinically-focused components for tissue repair and rejuvenation.' },
  texture: { title: 'Solution', features: ['Clear sterile ampoule'] },
  howToUse: ['Professional use: injection or mesotherapy protocols'],
  suitableFor: 'Aging or photo-damaged skin under professional supervision',
  category: 'injectable-serum',
  featured: true
},

{
  id: 'dermaheal-sb',
  name: 'Dermaheal SB (Skin Brightening)',
  subtitle: 'Brightening Ampoule for Uneven Tone',
  image: '/images/skinproducts/73.png',
  shortDescription: 'Formulated to reduce hyperpigmentation and brighten skin tone using targeted peptides and brightening actives.',
  keyBenefits: [
    { text: 'Reduces dark spots and pigmentation' },
    { text: 'Evens out skin tone' },
    { text: 'Supports overall skin radiance' }
  ],
  keyIngredient: { name: 'Brightening peptide complex', description: 'Targets melanin synthesis and supports brighter skin appearance.' },
  texture: { title: 'Ampoule', features: ['Concentrated liquid', 'For professional application'] },
  howToUse: ['Use in professional mesotherapy or topical protocols as instructed'],
  suitableFor: 'Hyperpigmented or uneven skin tone',
  category: 'brightening-serum',
  featured: true
},
{
  id: 'reezefats-anti-freezing-membrane',
  name: 'Reezefats Anti Freezing Membrane',
  subtitle: 'Anti-Freezing Protective Membrane',
  image: '/images/skinproducts/74.png',
  shortDescription: 'Protective membrane sheets designed to prevent freezing and protect sterile ampoules during transport and storage.',
  keyBenefits: [
    { text: 'Protects fragile ampoules during shipping' },
    { text: 'Thermal insulation properties' },
    { text: 'Easy to apply and dispose' }
  ],
  keyIngredient: { name: 'Thermal insulating membrane', description: 'Materials designed to limit temperature fluctuations.' },
  texture: { title: 'Sheet', features: ['Lightweight', 'Disposable', 'Protective'] },
  howToUse: ['Wrap ampoules during transport or store as recommended'],
  suitableFor: 'Shipping and storage of temperature-sensitive products',
  category: 'accessory',
  featured: false
 }
 ,
 {
  id: 'ultrasonic-scrubber-facial-cleaner',
  name: 'Ultrasonic Scrubber Facial Cleaner',
  subtitle: 'Deep Pore Exfoliation & Cleanser',
  image: '/images/skinproducts/75.png',
  shortDescription: 'Handheld ultrasonic skin scrubber that deeply exfoliates, removes blackheads, and improves product absorption for brighter, cleaner skin.',
  keyBenefits: [
    { text: 'Removes dead skin cells and blackheads' },
    { text: 'Improves serum absorption' },
    { text: 'Gentle exfoliation for sensitive skin' }
  ],
  keyIngredient: { name: 'Ultrasonic Vibration', description: 'High-frequency vibrations that loosen debris and promote gentle exfoliation.' },
  howToUse: [ 'Cleanse skin', 'Run device gently across damp skin', 'Use 1–2 times per week' ],
  suitableFor: 'Oily, combination, and congested skin',
  category: 'home-device',
  featured: false
 },
 {
  id: 'digital-microscope-1000x-wireless',
  name: 'Digital Microscope 1000x Wireless',
  subtitle: 'Wireless Skin & Scalp Inspection Microscope',
  image: '/images/skinproducts/76.png',
  shortDescription: 'Portable digital microscope for close-up inspection of skin and scalp conditions, useful for consultations and home monitoring.',
  keyBenefits: [ { text: 'High magnification for detailed inspection' }, { text: 'Wireless connection to phone or tablet' } ],
  keyIngredient: { name: 'Optical Lens + LED', description: 'High-magnification optics with built-in LED illumination.' },
  howToUse: [ 'Connect via Wi-Fi or USB', 'Focus on area of interest', 'Capture images for review' ],
  suitableFor: 'Clinicians and at-home monitoring',
  category: 'equipment',
  featured: false
 },
 {
  id: 'mesotherapy-radiofrequency-7color',
  name: 'Mesotherapy Radiofrequency 7 Color',
  subtitle: 'Multi-Function RF & LED Therapy Device',
  image: '/images/skinproducts/77.png',
  shortDescription: 'Handheld mesotherapy radiofrequency device with 7-color LED options for skin tightening, rejuvenation, and pore improvement.',
  keyBenefits: [ { text: 'Improves skin elasticity and firmness' }, { text: 'Combines RF heating with LED therapy' }, { text: 'Non-invasive rejuvenation' } ],
  keyIngredient: { name: 'RF + Multi-LED', description: 'Radiofrequency energy combined with multiple LED wavelengths for synergistic skin benefits.' },
  howToUse: [ 'Cleanse skin', 'Apply conductive gel if required', 'Treat area with selected mode' ],
  suitableFor: 'Sagging, dull, or uneven skin',
  category: 'device',
  featured: false
 },
 {
  id: 'led-mask-with-neck-facial',
  name: 'LED Mask With Neck Facial Mask',
  subtitle: 'Full Face & Neck LED Light Therapy Mask',
  image: '/images/skinproducts/78.png',
  shortDescription: 'Silicone LED therapy mask that covers face and neck with multiple light wavelengths to address acne, aging, and pigmentation.',
  keyBenefits: [ { text: 'Targets acne, inflammation, and signs of aging' }, { text: 'Full-face and neck coverage' } ],
  keyIngredient: { name: 'Multi-wavelength LEDs', description: 'Different LED colors target specific skin concerns like bacteria, collagen, and pigmentation.' },
  howToUse: [ 'Wear mask for recommended duration', 'Use 2–3 times per week' ],
  suitableFor: 'All skin types',
  category: 'light-therapy-device',
  featured: false
 },
 {
  id: 'silicon-led-light-therapy-face-mask',
  name: 'Silicon LED Light Therapy Face Mask',
  subtitle: 'Flexible Silicone LED Phototherapy Mask',
  image: '/images/skinproducts/79.png',
  shortDescription: 'Comfortable silicone LED mask with multiple color modes for at-home skin therapy to reduce acne and improve skin texture and tone.',
  keyBenefits: [ { text: 'Flexible silicone for comfortable fit' }, { text: 'Multiple LED color therapy modes' } ],
  keyIngredient: { name: 'Silicone + LEDs', description: 'Medical-grade silicone housing with embedded LED matrix.' },
  howToUse: [ 'Place mask on clean face', 'Select mode and duration', 'Use regularly for best results' ],
  suitableFor: 'Home LED therapy users',
  category: 'light-therapy-device',
  featured: false
 },
 {
  id: 'omega-light-7-colors-kiyo920',
  name: 'Omega Light 7 Colors Kiyo920',
  subtitle: '7-Color Professional LED Therapy Device',
  image: '/images/skinproducts/80.png',
  shortDescription: 'Compact LED therapy device offering seven light wavelengths for targeted skin treatments including acne reduction, collagen stimulation and calming.',
  keyBenefits: [ { text: 'Seven wavelengths for tailored treatments' }, { text: 'Portable and easy to use' } ],
  keyIngredient: { name: 'Multi-wavelength LED', description: 'Precision LED selection for various skin concerns.' },
  howToUse: [ 'Select wavelength', 'Apply treatment to target area', 'Use as directed by device guidelines' ],
  suitableFor: 'Professional and home use',
  category: 'light-therapy-device',
  featured: false
 },
 {
  id: '24k-gold-serum',
  name: '24K Gold Serum',
  subtitle: 'Luxury Anti-Aging Facial Serum',
  image: '/images/skinproducts/81.png',
  shortDescription: 'A premium facial serum infused with 24K gold particles to provide luxury skincare with anti-aging and brightening benefits.',
  keyBenefits: [
    { text: 'Provides anti-aging and rejuvenation effects' },
    { text: 'Brightens and illuminates dull skin' },
    { text: 'Reduces appearance of fine lines and wrinkles' },
    { text: 'Enhances skin elasticity and firmness' },
    { text: 'Delivers luxury skincare experience' }
  ],
  keyIngredient: {
    name: '24K Gold Particles',
    description: 'Premium gold particles provide anti-inflammatory benefits, improve circulation, and deliver a luxurious brightening effect to the skin.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight serum with gold particles',
      'Fast-absorbing formula',
      'Non-greasy finish with radiant glow'
    ]
  },
  howToUse: [
    'Cleanse your face thoroughly',
    'Apply a small amount of serum to face and neck',
    'Gently massage until fully absorbed',
    'Follow with moisturizer and sunscreen'
  ],
  suitableFor: 'All skin types, especially mature and dull skin',
  category: 'serum',
  featured: false
 },
 {
  id: 'ha-hyaluronic-acid-serum-vitamin-c',
  name: 'HA Hyaluronic Acid Serum Vitamin C',
  subtitle: 'Advanced Hydration & Brightening Complex',
  image: '/images/skinproducts/82.png',
  shortDescription: 'A potent serum combining Hyaluronic Acid and Vitamin C to deeply hydrate, brighten, and protect skin from environmental damage.',
  keyBenefits: [
    { text: 'Deep hydration with hyaluronic acid' },
    { text: 'Brightens and evens skin tone' },
    { text: 'Powerful antioxidant protection from Vitamin C' },
    { text: 'Reduces fine lines and promotes collagen synthesis' },
    { text: 'Suitable for sensitive and reactive skin' }
  ],
  keyIngredient: {
    name: 'Hyaluronic Acid + Vitamin C',
    description: 'Hyaluronic acid holds moisture for deep hydration while Vitamin C brightens, protects against free radicals, and boosts collagen production.'
  },
  texture: {
    title: 'Texture & Absorption',
    features: [
      'Lightweight, hydrating serum',
      'Quick-absorbing formula',
      'Non-sticky finish'
    ]
  },
  howToUse: [
    'Cleanse and dry face completely',
    'Apply a few drops to face and neck',
    'Gently pat until absorbed',
    'Follow with moisturizer and sunscreen (AM)'
  ],
  suitableFor: 'All skin types',
  category: 'serum',
  featured: false
 },
 {
  id: '24k-ampoule-serum-kygo-gold',
  name: '24K Ampoule Serum Kygo Gold',
  subtitle: 'Premium Gold-Infused Ampoule Serum',
  image: '/images/skinproducts/83.png',
  shortDescription: 'A concentrated ampoule serum enriched with 24K gold and Kygo technology for intensive anti-aging and skin revitalization.',
  keyBenefits: [
    { text: 'Intensive anti-aging treatment' },
    { text: 'Boosts skin luminosity and radiance' },
    { text: 'Improves skin texture and smoothness' },
    { text: 'Reduces wrinkles and fine lines' },
    { text: 'Provides luxury spa-like treatment at home' }
  ],
  keyIngredient: {
    name: '24K Gold + Kygo Technology',
    description: 'Premium gold particles combined with Kygo advanced technology deliver intensive rejuvenation, improved circulation, and radiant skin transformation.'
  },
  texture: {
    title: 'Presentation',
    features: [
      'Concentrated ampoule format',
      'Rich, nourishing texture',
      'Professional-grade treatment'
    ]
  },
  howToUse: [
    'Use one ampoule per treatment',
    'Cleanse face thoroughly',
    'Apply ampoule serum evenly',
    'Gently massage and leave for absorption',
    'Follow with night cream for enhanced results'
  ],
  suitableFor: 'Mature skin seeking intensive anti-aging',
  category: 'ampoule-serum',
  featured: false
 },
 {
  id: 'vitamin-c-face-essence-box',
  name: 'Vitamin C Face Essence Box',
  subtitle: 'Multi-Pack Brightening Essence',
  image: '/images/skinproducts/84.png',
  shortDescription: 'A set of 20 Vitamin C-infused essence treatments designed to brighten, protect, and rejuvenate skin with daily use.',
  keyBenefits: [
    { text: 'Brightens dull and tired skin' },
    { text: 'Provides powerful antioxidant protection' },
    { text: 'Improves skin clarity and glow' },
    { text: 'Boosts collagen production' },
    { text: 'Convenient daily treatment format' }
  ],
  keyIngredient: {
    name: 'Vitamin C (L-Ascorbic Acid)',
    description: 'A highly effective brightening and protective ingredient that stimulates collagen synthesis, reduces hyperpigmentation, and shields skin from environmental stressors.'
  },
  texture: {
    title: 'Presentation',
    features: [
      'Box of 20 individual essence treatments',
      'Lightweight essence texture',
      'Convenient daily use format'
    ]
  },
  howToUse: [
    'Use one essence daily or as needed',
    'Cleanse face thoroughly',
    'Apply essence evenly over face and neck',
    'Gently massage until absorbed',
    'Follow with moisturizer'
  ],
  suitableFor: 'All skin types seeking brightening and protection',
  category: 'essence',
  featured: false
 },
 {
  id: 'carbarn-peel-off-skin-rejuvenation',
  name: 'Carbarn Peel Off For Skin Rejuvenation',
  subtitle: 'Carbon-Based Peel-Off Mask',
  image: '/images/skinproducts/85.png',
  shortDescription: 'An innovative peel-off mask with carbon technology to deeply cleanse, exfoliate, and rejuvenate skin in one treatment.',
  keyBenefits: [
    { text: 'Deep cleansing action removing impurities' },
    { text: 'Gentle mechanical exfoliation' },
    { text: 'Reduces pores and improves skin texture' },
    { text: 'Brightens and revitalizes dull skin' },
    { text: 'Leaves skin smooth and refreshed' }
  ],
  keyIngredient: {
    name: 'Carbon Particles',
    description: 'Carbon powder provides deep cleansing, gentle exfoliation, and pore minimization while being safe for sensitive skin.'
  },
  texture: {
    title: 'Presentation & Application',
    features: [
      'Peel-off mask format',
      'Easy application and removal',
      'Visible carbon particles for cleansing action'
    ]
  },
  howToUse: [
    'Cleanse face and pat dry',
    'Apply thin, even layer to face (avoid eyes and lips)',
    'Wait 15-20 minutes until fully dry',
    'Gently peel off mask starting from edges',
    'Rinse any residue and follow with toner and moisturizer'
  ],
  suitableFor: 'All skin types, especially oily and congested skin',
  category: 'mask',
  featured: false
 },
 {
  id: 'jade-stone-roller-face-massager',
  name: 'Jade Stone Roller For Face Massager',
  subtitle: 'Traditional Chinese Jade Facial Tool',
  image: '/images/skinproducts/86.png',
  shortDescription: 'A classic jade stone facial roller that provides soothing facial massage, improves circulation, and reduces puffiness with traditional beauty benefits.',
  keyBenefits: [
    { text: 'Improves facial circulation and blood flow' },
    { text: 'Reduces puffiness and inflammation' },
    { text: 'Enhances product absorption' },
    { text: 'Provides soothing and relaxing massage' },
    { text: 'Natural cooling effect when chilled' }
  ],
  keyIngredient: {
    name: 'Natural Jade Stone',
    description: 'Premium jade stone has been used in traditional Chinese medicine for centuries to promote circulation, calm skin, and provide therapeutic benefits.'
  },
  texture: {
    title: 'Tool Features',
    features: [
      'Smooth jade stone surface',
      'Ergonomic roller design',
      'Durable and long-lasting',
      'Can be chilled for enhanced benefits'
    ]
  },
  howToUse: [
    'Start with clean skin or apply serum/moisturizer',
    'Chill roller in refrigerator for 5-10 minutes',
    'Roll gently upward from center of face outward',
    'Use on cheeks, forehead, and jawline',
    'Use 5-10 minutes daily for best results'
  ],
  suitableFor: 'All skin types',
  category: 'facial-tool',
  featured: false
 },

 {
  id: 'hair-removal-cooling-gel',
  name: 'Hair Removal Cooling Gel For Use',
  subtitle: 'Soothing IPL Treatment Companion',
  image: '/images/skinproducts/87.png',
  shortDescription: 'A specialized cooling gel designed to be used with hair removal devices for comfort, skin protection, and enhanced treatment results.',
  suitableFor: 'Use with IPL and laser hair removal devices',
  keyBenefits: [
    { text: 'Soothes skin during hair removal treatment' },
    { text: 'Provides cooling sensation for comfort' },
    { text: 'Protects skin from heat damage' },
    { text: 'Improves light transmission for better results' },
    { text: 'Reduces redness and irritation post-treatment' }
  ],
  keyIngredient: {
    name: 'Cooling Gel Complex',
    description: 'Specially formulated gel with cooling agents and skin-soothing ingredients to protect skin during IPL hair removal treatments.'
  },
  texture: {
    title: 'Presentation',
    features: [
      'Clear cooling gel',
      'Non-greasy formula',
      'Easy to apply and clean',
      'Dermatologist-tested'
    ]
  },
  howToUse: [
    'Apply thin layer of gel to treatment area',
    'Spread evenly across skin',
    'Use IPL device over gel-covered area',
    'Wipe off gel after treatment',
    'Rinse with cool water and pat dry'
  ],
  presentation: 'Cooling Gel Tube',
  category: 'hair-removal-support',
  featured: false
 },
 {
  id: 'bb-glow-kit-cream',
  name: 'BB Glow Kit BB Cream',
  subtitle: 'Brightening & Whitening BB Cream Treatment',
  image: '/images/skinproducts/88.png',
  shortDescription: 'Professional BB Glow cream kit designed to brighten, whiten, and unify skin tone with buildable coverage and natural finish.',
  keyBenefits: [
    { text: 'Brightens and whitens dull skin' },
    { text: 'Evens out skin tone and hyperpigmentation' },
    { text: 'Provides buildable medium to full coverage' },
    { text: 'Long-lasting formula resistant to sweat' },
    { text: 'Suitable for semi-permanent makeup applications' }
  ],
  keyIngredient: {
    name: 'BB Cream Complex with Brightening Agents',
    description: 'Advanced BB cream formulation combined with whitening and brightening complexes to provide professional-grade results.'
  },
  texture: {
    title: 'Presentation',
    features: [
      'Professional BB cream kit',
      'Smooth, blendable texture',
      'Long-wearing formula',
      'Multiple shades available'
    ]
  },
  howToUse: [
    'Cleanse and prep skin with moisturizer',
    'Apply thin layer and blend with brush or sponge',
    'Build coverage as needed',
    'Set with powder for extended wear',
    'Can be used as base for semi-permanent makeup'
  ],
  suitableFor: 'All skin types seeking brightening and coverage',
  category: 'bb-cream',
  featured: false
 },
 {
  id: 'bb-serum-booster-kit',
  name: 'BB Serum Booster Kit BB Serum',
  subtitle: 'Enhanced Brightening Serum Treatment',
  image: '/images/skinproducts/89.png',
  shortDescription: 'Professional BB serum booster kit with powerful brightening and skin-boosting properties for enhanced luminosity and skin refinement.',
  keyBenefits: [
    { text: 'Intense skin brightening and whitening' },
    { text: 'Energizes and boosts skin vitality' },
    { text: 'Improves skin clarity and glow' },
    { text: 'Lightweight serum format for layering' },
    { text: 'Fast absorption with immediate visible results' }
  ],
  keyIngredient: {
    name: 'BB Serum Complex with Brightening Peptides',
    description: 'Potent serum formula combining brightening agents and peptides to deliver professional results for luminous, refined skin.'
  },
  texture: {
    title: 'Presentation & Texture',
    features: [
      'Lightweight serum texture',
      'Non-sticky formula',
      'Fast-absorbing',
      'Professional-grade booster'
    ]
  },
  howToUse: [
    'Apply to cleansed face and neck',
    'Use morning and evening',
    'Can layer under moisturizer or BB cream',
    'Best results with consistent daily application',
    'Compatible with other skincare products'
  ],
  suitableFor: 'All skin types seeking brightening boost',
  category: 'serum',
  featured: false
 },
 {
  id: 'bb-glow-mix-serum-cream',
  name: 'BB Glow Mix BB Serum And Cream Kit',
  subtitle: 'Complete Brightening System Serum & Cream',
  image: '/images/skinproducts/90.png',
  shortDescription: 'Comprehensive BB Glow treatment kit combining serum and cream for synergistic brightening, whitening, and skin rejuvenation.',
  keyBenefits: [
    { text: 'Complete two-step brightening system' },
    { text: 'Serum + cream combination for enhanced results' },
    { text: 'Brightens and whitens effectively' },
    { text: 'Deeply hydrates and nourishes skin' },
    { text: 'Professional results with prolonged effects' }
  ],
  keyIngredient: {
    name: 'BB Brightening Complex + Hydrating Cream Base',
    description: 'Dual-formula system where the serum delivers active brightening ingredients and the cream locks in hydration and nourishment.'
  },
  texture: {
    title: 'Dual-Format System',
    features: [
      'Lightweight BB serum',
      'Rich nourishing cream',
      'Complementary formulas',
      'Professional kit presentation'
    ]
  },
  howToUse: [
    'Step 1: Apply BB serum to clean skin',
    'Step 2: Follow with BB cream',
    'Use morning and evening',
    'Massage gently until fully absorbed',
    'Can be used daily or as intensive treatment'
  ],
  suitableFor: 'All skin types, especially dry and dull skin',
  category: 'treatment-kit',
  featured: false
 },
 {
  id: 'neeravive-kit-capsules-gels',
  name: 'Neeravive Kit Capsules And Gels',
  subtitle: 'Advanced Skincare Capsule & Gel System',
  image: '/images/skinproducts/91.png',
  shortDescription: 'Professional skincare kit combining innovative capsule technology with gel formulations for targeted skin treatment and visible results.',
  keyBenefits: [
    { text: 'Innovative capsule-in-gel technology' },
    { text: 'Precise ingredient delivery' },
    { text: 'Targets specific skin concerns' },
    { text: 'Professional-grade treatment' },
    { text: 'Visible results with consistent use' }
  ],
  keyIngredient: {
    name: 'Encapsulated Active Ingredients + Gel Base',
    description: 'Advanced delivery system where active capsules release targeted ingredients through gel matrix for maximum efficacy and absorption.'
  },
  texture: {
    title: 'Presentation & Application',
    features: [
      'Dual capsule-gel system',
      'Precise targeting formulation',
      'Professional treatment kit',
      'Easy application method'
    ]
  },
  howToUse: [
    'Cleanse skin thoroughly',
    'Apply gel base to treatment area',
    'Add capsules as directed',
    'Gently massage and allow absorption',
    'Use as intensive treatment 2-3 times weekly'
  ],
  suitableFor: 'All skin types with specific treatment needs',
  category: 'treatment-kit',
  featured: false
 },
 {
  id: 'nee-bright-kit-skin-lightening',
  name: 'Nee Bright Kit Skin Lightening Cream',
  subtitle: 'Professional Skin Brightening & Lightening System',
  image: '/images/skinproducts/92.png',
  shortDescription: 'Professional-grade skin lightening and brightening cream kit designed to reduce hyperpigmentation and achieve even, radiant complexion.',
  keyBenefits: [
    { text: 'Effective skin lightening and whitening' },
    { text: 'Reduces dark spots and hyperpigmentation' },
    { text: 'Brightens overall complexion' },
    { text: 'Safe professional formulation' },
    { text: 'Visible results in 2-4 weeks' }
  ],
  keyIngredient: {
    name: 'Advanced Lightening Complex with Arbutin & Kojic Acid',
    description: 'Professional-grade blend of proven lightening agents including arbutin, kojic acid, and brightening peptides for safe, effective skin lightening.'
  },
  texture: {
    title: 'Cream Formulation',
    features: [
      'Rich, nourishing cream',
      'Professional-strength formula',
      'Non-irritating composition',
      'Smooth application texture'
    ]
  },
  howToUse: [
    'Use on clean, dry skin',
    'Apply morning and evening',
    'Use SPF 50+ during day (essential)',
    'Consistent application for best results',
    'Results visible after 2-4 weeks of use'
  ],
  suitableFor: 'Hyperpigmented, dark, and uneven skin tone',
  category: 'brightening-cream',
  featured: false
 },
 {
  id: 'hydra-serum-liquid-solution',
  name: 'Hydra Serum Liquid Solution AS1',
  subtitle: 'Multi-Option Hydrating Serum Solution',
  image: '/images/skinproducts/93.png',
  shortDescription: 'Professional hydrating serum solution available in three specialized formulations (SA1, AS1, AQ1) for customized skin treatment and deep hydration.',
  keyBenefits: [
    { text: 'Intense hydration and moisture retention' },
    { text: 'Three specialized formulations for different needs' },
    { text: 'Lightweight serum texture' },
    { text: 'Fast absorption without stickiness' },
    { text: 'Suitable for all hydration concerns' }
  ],
  keyIngredient: {
    name: 'Hydrating Serum Complex (Multiple Formulations)',
    description: 'SA1: Soothing & Antioxidant formula | AS1: Advanced Serum formula | AQ1: Aqua-intensive hydration formula. Each targets specific hydration and skin needs.'
  },
  texture: {
    title: 'Presentation & Variants',
    features: [
      'SA1 - Soothing & Antioxidant variant',
      'AS1 - Advanced Serum variant',
      'AQ1 - Aqua-intensive variant',
      'Lightweight liquid serum texture'
    ]
  },
  howToUse: [
    'Choose appropriate variant for your skin type',
    'Apply to clean face and neck',
    'Use morning and evening',
    'Pat in gently for absorption',
    'Follow with moisturizer for sealed hydration'
  ],
  variants: [
    { name: 'SA1 - Soothing & Antioxidant', description: 'For sensitive and reactive skin' },
    { name: 'AS1 - Advanced Serum', description: 'For comprehensive skin treatment' },
    { name: 'AQ1 - Aqua-Intensive', description: 'For dehydrated and ultra-dry skin' }
  ],
  suitableFor: 'All skin types, choose variant by specific need',
  category: 'serum',
  featured: false
 },
 {
  id: 'charmient-princess-tattoo-pen',
  name: 'Charmient Princess Tattoo Pen Touch',
  subtitle: 'Professional Semi-Permanent Makeup Pen',
  image: '/images/skinproducts/94.png',
  shortDescription: 'Advanced semi-permanent makeup (micropigmentation) pen with multiple mode options for precise eyebrow, lip, and eyeliner tattooing with professional results.',
  keyBenefits: [
    { text: 'Professional-grade micropigmentation device' },
    { text: 'Multiple mode selections for different techniques' },
    { text: 'Precise control for detailed work' },
    { text: 'Comfortable touch design for extended use' },
    { text: 'Creates natural-looking, long-lasting tattooed makeup' }
  ],
  keyIngredient: {
    name: 'Advanced Tattooing Technology',
    description: 'High-precision micropigmentation pen with adjustable settings for eyebrow design, lip coloring, eyeliner application, and other semi-permanent makeup procedures.'
  },
  texture: {
    title: 'Device Features',
    features: [
      'Ergonomic touch design',
      'Multiple mode settings (eyes, lips, eyebrows, smile and more)',
      'Professional-grade precision',
      'Comfortable grip for extended sessions',
      'Digital interface display'
    ]
  },
  howToUse: [
    'Select appropriate mode for desired application',
    'Connect compatible needle cartridge',
    'Adjust depth and settings for skin type',
    'Apply micropigmentation to prepared skin area',
    'Follow post-care instructions for optimal healing',
    'Touch-up sessions recommended every 12-18 months'
  ],
  suitableFor: 'Semi-permanent makeup for eyebrows, lips, eyeliner, and other facial features',
  category: 'micropigmentation-device',
  featured: false
 },
 {
  id: 'charmient-needles-cartridge',
  name: 'Charmient Needles For Tattoo Pen',
  subtitle: 'Disposable Needle Cartridges (1R, 3R, 5R, 5F)',
  image: '/images/skinproducts/95.png',
  shortDescription: 'Professional disposable needle cartridges designed for Charmient tattoo pens in multiple configurations for various micropigmentation techniques.',
  keyBenefits: [
    { text: 'Sterile, single-use needle cartridges' },
    { text: 'Multiple needle configurations for different techniques' },
    { text: 'Compatible with Charmient tattoo systems' },
    { text: 'Ensures precision and safety' },
    { text: 'Prevents cross-contamination' }
  ],
  keyIngredient: {
    name: 'Medical-Grade Stainless Steel Needles',
    description: 'Precision-engineered stainless steel needles in different configurations (1R: single round, 3R: triple round, 5R: five round, 5F: five flat) for specific micropigmentation applications.'
  },
  texture: {
    title: 'Needle Configurations',
    features: [
      '1R - Single round needle for fine lines and details',
      '3R - Triple round needle for medium applications',
      '5R - Five round needle for larger areas',
      '5F - Five flat needle for shading and fills',
      'Medical-grade stainless steel',
      'Individually packaged and sterilized'
    ]
  },
  howToUse: [
    'Select appropriate needle configuration for your design',
    'Install cartridge into Charmient tattoo pen',
    'Ensure secure connection before use',
    'Use single cartridge for one patron to prevent infection',
    'Dispose of cartridge after single use',
    'Store unused cartridges in sterile, dry environment'
  ],
  variants: [
    { name: '1R - Single Round', description: 'Fine lines and detailed work' },
    { name: '3R - Triple Round', description: 'Medium precision applications' },
    { name: '5R - Five Round', description: 'Larger shading areas' },
    { name: '5F - Five Flat', description: 'Full coverage and color fills' }
  ],
  suitableFor: 'Professional micropigmentation and semi-permanent makeup procedures',
  category: 'tattoo-needles',
  featured: false
 },
 {
  id: 'portable-high-frequency-skin',
  name: 'Portable High Frequency For Skin T1',
  subtitle: 'Professional High-Frequency Skin Treatment Device',
  image: '/images/skinproducts/96.png',
  shortDescription: 'Portable high-frequency skin treatment device for acne reduction, circulation improvement, and skin rejuvenation with multiple application attachments.',
  keyBenefits: [
    { text: 'Reduces acne and bacterial infections' },
    { text: 'Improves blood circulation and cellular renewal' },
    { text: 'Minimizes pores and evens skin texture' },
    { text: 'Portable and easy to use at home or clinic' },
    { text: 'Non-invasive skin treatment solution' }
  ],
  keyIngredient: {
    name: 'High-Frequency Electrical Technology',
    description: 'Generates high-frequency electrical currents that kill bacteria, improve circulation, and stimulate skin renewal without damaging healthy tissue.'
  },
  texture: {
    title: 'Device Specifications',
    features: [
      'Portable handheld design',
      'Multiple glass electrode attachments for different areas',
      'Adjustable frequency settings',
      'Safe, non-invasive application',
      'Professional clinical results'
    ]
  },
  howToUse: [
    'Select appropriate glass electrode for desired application',
    'Start with lowest frequency setting',
    'Apply electrode to clean, dry skin',
    'Move electrode slowly across treatment area',
    'Use 2-3 minutes per area, 3-4 times weekly',
    'Best results after 6-8 weeks of regular use'
  ],
  suitableFor: 'Acne-prone, oily, congested skin; anti-aging and rejuvenation',
  category: 'electrotherapy-device',
  featured: false
 },
 {
  id: 'smb-laser-spot-remover',
  name: 'SMB Laser Spot Remover Face Lift W',
  subtitle: 'Professional Laser Spot Removal & Skin Lifting System',
  image: '/images/skinproducts/97.png',
  shortDescription: 'Professional-grade laser device combining spot removal and micro-lifting technology with multiple color options for age spots, pigmentation, and skin tightening.',
  keyBenefits: [
    { text: 'Effectively removes age spots and dark spots' },
    { text: 'Reduces pigmentation and skin discoloration' },
    { text: 'Provides micro-lifting for skin tightening' },
    { text: 'Non-invasive with minimal downtime' },
    { text: 'Multiple device color options for different applications' }
  ],
  keyIngredient: {
    name: 'Advanced Laser Technology with Lifting Function',
    description: 'Combines laser pigmentation removal with micro-lifting thermal effects to address age spots while simultaneously tightening skin for facial lift benefits.'
  },
  texture: {
    title: 'Device Features & Variants',
    features: [
      'Professional laser spot remover',
      'Multiple color/variant options',
      'Precise targeting for spots and pigmentation',
      'Integrated skin lifting technology',
      'Adjustable laser intensity',
      'Safe for facial and body treatment'
    ]
  },
  howToUse: [
    'Consult professional before treatment',
    'Apply protective eyewear',
    'Prepare skin with cleansing',
    'Select appropriate laser setting for specific concern',
    'Apply laser to pigmented areas or treatment zones',
    'Post-treatment care with SPF and moisturizer essential',
    'Multiple sessions may be needed for optimal results'
  ],
  variants: [
    { name: 'Option 1 - Standard White', description: 'General spot and pigmentation removal' },
    { name: 'Option 2 - Pro Gold', description: 'Enhanced lifting with anti-aging benefits' },
    { name: 'Option 3 - Advanced Black', description: 'Intensive pigmentation targeting' },
    { name: 'Option 4 - Premium Silver', description: 'Multi-functional comprehensive treatment' }
  ],
  suitableFor: 'Age spots, dark spots, hyperpigmentation, and skin tightening',
  category: 'laser-treatment-device',
  featured: false
 },
{
  id: 'mini-ozone-cold-plasma-pen',
  name: 'Mini Ozone Cold Plasma Pen',
  subtitle: 'Portable Cold Plasma & Ozone Skin Therapy Device',
  image: '/images/skinproducts/100.png',
  shortDescription: 'Compact cold plasma pen delivering ozone-enriched plasma for wound healing, skin rejuvenation, and fibroblast stimulation.',
  keyBenefits: [
    { text: 'Promotes wound healing and skin regeneration' },
    { text: 'Stimulates fibroblast activity and collagen production' },
    { text: 'Antibacterial and antiseptic ozone effect' },
    { text: 'Non-invasive, precise spot treatment' },
    { text: 'Portable and easy-to-use for clinic or home use' }
  ],
  keyIngredient: {
    name: 'Cold Plasma with Ozone',
    description: 'Generates low-temperature plasma combined with controlled ozone release to support tissue repair, disinfection, and cellular stimulation.'
  },
  texture: {
    title: 'Device Features',
    features: [
      'Compact handheld design',
      'Multiple tip attachments for different zones',
      'Adjustable intensity settings',
      'Battery-powered and rechargeable',
      'Safe low-temperature plasma output'
    ]
  },
  howToUse: [
    'Clean and disinfect treatment area',
    'Select appropriate tip and attach to the pen',
    'Start with lowest intensity and increase as needed',
    'Apply short passes over targeted spots for 1–3 minutes',
    'Use per manufacturer instructions and avoid prolonged exposure',
    'Recommended for professional use or under guidance'
  ],
  suitableFor: 'Minor skin wounds, acne lesions, post-procedure care, and skin rejuvenation',
  category: 'plasma-device',
  featured: false
},
{
  id: 'illuminate-pod-kit',
  name: 'Illuminate POD',
  subtitle: 'Complete Skin Illumination & Brightening System',
  image: '/images/skinproducts/98.png',
  shortDescription: 'Comprehensive beauty pod system with multiple illuminating and brightening treatments for radiant, glowing skin transformation.',
  keyBenefits: [
    { text: 'Complete illumination and brightening system' },
    { text: 'Multiple product options in one pod' },
    { text: 'Professional-grade treatment results' },
    { text: 'Enhances natural skin radiance and glow' },
    { text: 'Easy-to-use pod format' }
  ],
  keyIngredient: {
    name: 'Advanced Illuminating Complex',
    description: 'Multi-component brightening system combining illuminating peptides, light-reflecting particles, and skin-radiance enhancers for comprehensive glow.'
  },
  texture: {
    title: 'Pod System Components',
    features: [
      'Multiple illuminating treatments',
      'Complementary product formulas',
      'Professional-grade formulation',
      'Easy Pod format for convenience',
      'Light yellow shade for radiance effect'
    ]
  },
  howToUse: [
    'Select desired treatment from pod options',
    'Cleanse face thoroughly',
    'Apply illuminating treatment as directed',
    'Massage gently for even coverage',
    'Allow absorption for optimal glow',
    'Can be layered with other products',
    'Use daily or as intensive treatment'
  ],
  suitableFor: 'All skin types seeking enhanced radiance and illumination',
  category: 'illumination-system',
  featured: false
 },
 {
  id: 'charcoal-mask-deep-cleaning',
  name: 'Charcoal Mask Deep Cleaning Mask',
  subtitle: 'Professional Charcoal Detoxifying Mask',
  image: '/images/skinproducts/99.png',
  shortDescription: 'Professional-grade charcoal detoxifying mask for deep pore cleansing, impurity removal, and comprehensive skin detoxification.',
  keyBenefits: [
    { text: 'Deep pore cleansing and purification' },
    { text: 'Removes impurities, oil, and toxins' },
    { text: 'Detoxifies congested skin' },
    { text: 'Minimizes pores and refines texture' },
    { text: 'Leaves skin feeling clean and refreshed' }
  ],
  keyIngredient: {
    name: 'Activated Charcoal with Detoxifying Agents',
    description: 'Medical-grade activated charcoal combined with detoxifying plant extracts to absorb impurities, draw out toxins, and deeply cleanse skin.'
  },
  texture: {
    title: 'Mask Formulation',
    features: [
      'Rich, creamy charcoal mask base',
      'Dark charcoal color for visible detoxification',
      'Easily spreadable texture',
      'Professional-grade formulation',
      'Easy to rinse without residue'
    ]
  },
  howToUse: [
    'Cleanse face and pat dry',
    'Apply thin, even layer of charcoal mask',
    'Avoid eye area and lips',
    'Leave on for 10-15 minutes or until dry',
    'Rinse thoroughly with lukewarm water',
    'Pat dry and apply toner and moisturizer',
    'Use 1-2 times per week for maintenance'
  ],
  suitableFor: 'Oily, congested, acne-prone skin; intensive detoxification treatment',
  category: 'mask',
  featured: false
 }
];











  


// Helper function to get product by ID
export const getProductById = (id) => {
  if (!id) return undefined;
  return skinProducts.find(product => product && product.id === id);
};

// Helper function to get featured products
export const getFeaturedProducts = () => {
  return skinProducts.filter(product => product.featured);
};

